import { SourceDataInitials } from "@/constants/SourceDataInitials";

export default class FakePayloadPR {

    static loadFakeData(sourceDataInitial: string, isSubject: boolean): any {
        if(sourceDataInitial === SourceDataInitials.PublicRecords) {
            return isSubject ? PRSubjectPayload() : PRCompPayload();
        } else if(sourceDataInitial === SourceDataInitials.SmartExchange) {
            return isSubject ? SEBestSubjectPayload() : SEBestCompPayload();
        } else if(sourceDataInitial === SourceDataInitials.Database) {
            return isSubject ? DBBestSubjectPayload() : DBBestCompPayload();
        }
    }

}

function DBBestSubjectPayload(): any {
        const data = {
            "records": 2,
            "yourCount": 0,
            "peerCount": 2,
            "reportUseCount": 1,
            "isPeerComp": true,
            "sourceData": {
                "SUB_PHOTO": "",
                "SUBPROPADDRESS": "539 Shirley LN NE",
                "SUBUNITNO": "",
                "SUBCITY": "Piedmont",
                "SUBSTATE": "OK",
                "SUBZIP": "73078",
                "SUBCOUNTY": "Oklahoma",
                "SUBPROJNAME": "EASTWIND ESTATES",
                "ATTACHMENT_TYPE": "Detached",
                "ProjectType": {
                    "PROJECT_TYPE_FLATTENED": "",
                    "PUD_YES": "",
                    "PUD_NO": "X",
                    "CONDO_YES": "",
                    "CONDO_NO": "X",
                    "COOP_YES": "",
                    "COOP_NO": "X",
                    "CONDOP_YES": "",
                    "CONDOP_NO": ""
                },
                "NativeAmericanLands": {
                    "NATAMLAND_FLATTENED": "",
                    "NATAMLAND_YES": "",
                    "NATAMLAND_NO": ""
                },
                "SiteOwnedInCommon": {
                    "SITE_OWNED_IN_COMMON_FLATTENED": "",
                    "SITOWNEDCOMMON_YES": "",
                    "SITOWNEDCOMMON_NO": ""
                },
                "HomeownerResponsible": {
                    "HORESPMAINT_FLATTENED": "X",
                    "HORESPMAINT_YES": "X",
                    "HORESPMAINT_NO": ""
                },
                "NewConstruction": {
                    "NEWCONST_FLATTENED": "",
                    "NEWCONST_YES": "",
                    "NEWCONST_NO": "X"
                },
                "PROPRIGHTSAPPR": "",
                "GROUND_RENTAL_ANNUAL_AMOUNT": "",
                "ALL_RIGHTS_INCLUDED": "",
                "RIGHTS_NOT_INCLUDED": "",
                "SUBLEGALDESCRIP": "PT LL 48 10/4",
                "Owners": [
                    {
                        "SUBCUROWNER": "JOHN CROWE",
                        "SUBCUROWNER_TYPE": "Individual",
                        "SUBCUROWNER_FIRST_NAME": "JOHN",
                        "SUBCUROWNER_MIDDLE_NAME": "",
                        "SUBCUROWNER_LAST_NAME": "CROWE",
                        "SUBCUROWNER_SUFFIX_NAME": "",
                        "SUBCUROWNER_FULL_NAME": "JOHN CROWE",
                    },
                    {
                        "SUBCUROWNER": "BRENDA CROWE",
                        "SUBCUROWNER_TYPE": "LegalEntity",
                        "SUBCUROWNER_FIRST_NAME": "",
                        "SUBCUROWNER_MIDDLE_NAME": "",
                        "SUBCUROWNER_LAST_NAME": "",
                        "SUBCUROWNER_SUFFIX_NAME": "",
                        "SUBCUROWNER_FULL_NAME": "BRENDA CROWE",
                    }
                ],
                "LATITUDE": "34.962639",
                "LONGITUDE": "-85.423553",
                "SITSITEAREA": "147233",
                "NUMPARCELS": "1",
                "PU_APN": "0520002000",
                "PU_ALT_APN": "052-00-020-00",
                "PU_APN_DESC": "",
                "PU_SOURCE_APN": "Data Aggregator",
                "PARCEL_SIZE": "147233",
                "SIT_COMPLIANCE": "",
                "SIT_PRIMACCESS": "Public Street",
                "SiteStreetType": [
                    {
                        "SIT_STREET_TYPE_SURFACE": "Cul-de-sac | Paved",
                        "PU_STREET_TYPE": "Cul-de-sac",
                        "PU_SURFACE_TYPE": "Paved"
                    },
                    {
                        "SIT_STREET_TYPE_SURFACE": "Dead End | Paved",
                        "PU_STREET_TYPE": "Dead End",
                        "PU_SURFACE_TYPE": "Paved"
                    }
                ],
                "SiteInfluence": [
                    {
                        "SIT_INFL_FLATTENED": "",
                        "SIT_INFL_INFL": "",
                        "PU_SITE_INFL_WTR_DTL_TYPE": "",
                        "PU_SITE_INFL_WTR_DTL_PRIV_ACCESS": ""
                    }
                ],
                "ViewImpairment": [
                    {
                        "SIT_VWIMP_VIEW_FLATTENED": "",
                        "SIT_VWIMP_VIEW": "",
                        "SIT_VWIMP_RNGVW": "",
                        "SIT_VWIMP_IMP": ""
                    }
                ],
                "SiteFeatures": [
                    {
                        "SIT_FEAT_HZRD_ZONE_DTL": "",
                        "SIT_FEAT_RSTRCTN_DTL": "",
                        "PU_SITE_FEAT_SITCHAR": "",
                        "PU_SITE_FEAT_SITCHAR_TOP_TYPE": "",
                        "PU_SITE_FEAT_SITCHAR_DRAIN_RSN": "",
                        "SIT_FEAT_EASEMENT_DTL": ""
                    }
                ],
                "DM_MITIGATION_FEATURE": "",
                "RenewableEnergyComponents": [
                    {
                        "EE_RENEWABLES": "",
                        "PU_EE_RENEWABLE_TYPE": "",
                        "PU_EE_OWNER_TYPE": "",
                        "PU_EE_FINANCING_ARRANGEMENT_YES": "",
                        "PU_EE_FINANCING_ARRANGEMENT_NO": ""
                    }
                ],
                "BuildingCertifications": [
                    {
                        "EE_CERTS_ORGANIZATION_FLATTENED": "",
                        "EE_CERTS_ORGANIZATION": "",
                        "EE_CERTS": "",
                        "EE_YEAR": "",
                        "EE_VERSION": "",
                        "EE_RATING": ""
                    }
                ],
                "EfficiencyRatings": [
                    {
                        "EE_GREEN_EFF_FLATTENED": "",
                        "EE_GREEN_EFF": "",
                        "EE_GREEN_RATING": "",
                        "EE_GREEN_SCORE": ""
                    }
                ],
                "EE_IMPACT_TO_VAL": "",
                "EE_DESCRIPTION": "",
                "PI_PROJ_NAME": "",
                "PI_MONTHLY_AMOUNT": "",
                "PU_MONTHLY_AMOUNT": "",
                "PU_ASSOCIATION_CHARGE_TYPE_AD": "",
                "PI_AMENITIES_SERVICES_INCLUDED": "",
                "PU_AMENITIES_SERVICES_INCLUDED": "",
                "UNIT_SPECIAL_ASSESSMENTS_FLATTENED": "",
                "PU_UNIT_SPECIAL_ASSESSMENTS_DETAIL": "",
                "PU_UNIT_SPECIAL_ASSESSMENTS_AMNT": "",
                "HOME_WIDTH": "",
                "SaleListingInformation": [
                    {
                        "SLI_LIST_STATUS": "",
                        "SLI_LIST_CUR_OR_FINAL_LP": ""
                    }
                ],
                "Dwellings": [
                    {
                        "UNIT_NUMS": "",
                        "STRUCTURE_DESIGN_TYPE": "",
                        "STYLE": "",
                        "FRONT_DOOR_ELEV": "",
                        "TOWNHOUSE_END_UNIT": "",
                        "TOWNHOUSE_BACK2BACK": "",
                        "UNITS_ABOVE_OR_BELOW": "",
                        "TOWNHOUSE_LOC": "",
                        "PUIYRBUILT": "2012",
                        "PUIYRBUILT_ESTIMATED": "No",
                        "CONST_METHOD": "",
                        "CONVERTED_AREA": "",
                        "STRUCTURE_VOL": "",
                        "WINDOW_SURFACE_AREA": "",
                        "GROSS_FINISHED_AREA_SF": "",
                        "EXT_QUAL_RATING": "",
                        "EXT_COND_RATING": "",
                        "EXTEXTWALLS": "Stone",
                        "EXT_FEAT_COND_STATUS": "",
                        "Foundations": [
                            {
                                "EXT_FOUNDATION_DETAIL": "Sand | Natural",
                                "EXT_FOUNDATION_MATERIAL_DETAIL": "Sand",
                                "EXT_FOUNDATION_TYPE_DETAIL": "Natural",
                                "EXT_FOUNDATION_STATUS": ""
                            },
                            {
                                "EXT_FOUNDATION_DETAIL": "Brick | Natural",
                                "EXT_FOUNDATION_MATERIAL_DETAIL": "Brick",
                                "EXT_FOUNDATION_TYPE_DETAIL": "Natural",
                                "EXT_FOUNDATION_STATUS": ""
                            }
                        ],
                        "EXT_WINDOW_DETAIL_FLATTENED": "",
                        "EXT_WINDOW_DETAIL": "",
                        "EXT_WINDOW_STATUS": "",
                        "Roof": {
                            "EXTRFSURFACE": "",
                            "EXTRFSURFACE_OBSERVABLE": "",
                            "EXTRFSURFACE_TYPE": "",
                            "EXTRFSURFACE_AGE": "",
                        },
                        "EXTRFSURFACE_TYPE": "Asphalt",
                        "EXTRFSURFACE_OBSERVABLE": "Yes",
                        "FinishedAreaRoomSummary": [
                            {
                                "FINISHED_AREA_TOTAL_AREA_FLATTENED": "",
                                "FINISHED_AREA_TOTAL_AREA": "2300",
                                "FINISHED_AREA_ROOM_SUMMARY_TOTAL_ROOM": "",
                                "FINISHED_AREA_ROOM_SUMMARY_ROOM_TYPE": ""
                            }
                        ],
                        "Heating": [
                            {
                                "HEAT_SYSTEM_FLATTENED": "Fireplace | Wood ",
                                "HEAT_SYSTEM": "Fireplace",
                                "HEAT_DETAIL": "Electric"
                            },
                            {
                                "HEAT_SYSTEM_FLATTENED": "Baseboard | Natural Gas ",
                                "HEAT_SYSTEM": "Baseboard",
                                "HEAT_DETAIL": "Natural Gas"
                            }
                        ],
                        "Cooling": [
                            {
                                "COOL_SYSTEM": "Centralized",
                            }
                        ],
                        "OTHER_MECH_SYSTEM": "Test Data",
                        "Units": [
                            {
                                "FINISHED_ABOVE_GRADE": "",
                                "FINISHED_ABOVE_GRADE_NONSTD": "",
                                "UNFINISHED_ABOVE_GRADE": "",
                                "FINISHED_BELOW_GRADE": "",
                                "FINISHED_BELOW_GRADE_NONSTD": "",
                                "AREA_DATA_SOURCE_TYPE": "Public Records",
                                "UNIT_LEVELS": "",
                                "OCCUPANCY": "Owner",
                                "FLOOR_NUMBER": "",
                                "CORNER_UNIT": "",
                                "TOT_BEDS": "5",
                                "TOT_BATHS_FULL": "3",
                                "TOT_BATHS_HALF": "1",
                                "Levels": [
                                    {
                                        "LEVEL_IN_UNIT_FLATTENED": "Level 1 | Above Grade | 3006 | 0",
                                        "LEVEL_IN_UNIT": "Level 1",
                                        "LEVEL_GRADE_TYPE": "Above Grade",
                                        "LEVEL_BELOW_GRADE_ACCESS": "",
                                        "LEVEL_BELOW_GRADE_EXTERIOR_ACCESS": "",
                                        "LEVEL_FINISHED_AREA": "3006",
                                        "LEVEL_FINISHED_AREA_NONSTANDARD": "",
                                        "LEVEL_UNFINISHED_AREA": "0"
                                    },
                                    {
                                        "LEVEL_IN_UNIT_FLATTENED": "Level 2 | Above Grade | 1127 | 0",
                                        "LEVEL_IN_UNIT": "Level 2",
                                        "LEVEL_GRADE_TYPE": "Above Grade",
                                        "LEVEL_BELOW_GRADE_ACCESS": "",
                                        "LEVEL_BELOW_GRADE_EXTERIOR_ACCESS": "",
                                        "LEVEL_FINISHED_AREA": "1127",
                                        "LEVEL_FINISHED_AREA_NONSTANDARD": "",
                                        "LEVEL_UNFINISHED_AREA": "0"
                                    }
                                ],
                                "Rooms": [
                                    {
                                        "ROOM_LEVEL_FLATTENED": "Level B1 | Bedroom",
                                        "ROOM_LEVEL": "Level B1",
                                        "ROOM_ROOM_TYPE": "Bedroom"
                                    },
                                    {
                                        "ROOM_LEVEL_FLATTENED": "Level B1 | Bedroom",
                                        "ROOM_LEVEL": "Level B1",
                                        "ROOM_ROOM_TYPE": "Bedroom"
                                    },
                                    {
                                        "ROOM_LEVEL_FLATTENED": "Level B1 | Bedroom",
                                        "ROOM_LEVEL": "Level B1",
                                        "ROOM_ROOM_TYPE": "Bedroom"
                                    },
                                    {
                                        "ROOM_LEVEL_FLATTENED": "Level 1 | Bedroom",
                                        "ROOM_LEVEL": "Level 1",
                                        "ROOM_ROOM_TYPE": "Bedroom"
                                    },
                                    {
                                        "ROOM_LEVEL_FLATTENED": "Level 1 | Bedroom",
                                        "ROOM_LEVEL": "Level 1",
                                        "ROOM_ROOM_TYPE": "Bedroom"
                                    },
                                    {
                                        "ROOM_LEVEL_FLATTENED": "Level 1 | Bath - Full",
                                        "ROOM_LEVEL": "Level 1",
                                        "ROOM_ROOM_TYPE": "Bath - Full"
                                    },
                                    {
                                        "ROOM_LEVEL_FLATTENED": "Level 1 | Bath - Full",
                                        "ROOM_LEVEL": "Level 1",
                                        "ROOM_ROOM_TYPE": "Bath - Full"
                                    }
                                ],
                                "Mechanical": [
                                    {
                                        "OTHER_MECH_SYSTEM": ""
                                    }
                                ]
                            }
                        ],
                        "HEAT_BELOW_GRADE_FLATTENED": "",
                        "HEAT_BELOW_GRADE_YES": "",
                        "HEAT_BELOW_GRADE_NO": "",
                        "Defects": [
                            {
                                "DEFECT_FEATURE_FLATTENED": "",
                                "DEFECT_FEATURE": "",
                                "DEFECT_LOCATION": "",
                                "DEFECT_DESC": "",
                                "DEFECT_INTEGRITY": "",
                                "DEFECT_RECOMMEND_ACTION": ""
                            }
                        ]
                    }
                ],
                "VehicleStorage": [
                    {
                        "VS_CAR_STORAGE": "Garage | Attached | 1170",
                        "VS_PU_STORAGE_NUMBER_SPACES": "",
                        "VS_PU_STORAGE_SPACE_SQUARE_FEET": "1170",
                        "VS_PU_CAR_STORAGE_YES": "",
                        "VS_PU_CAR_STORAGE_NO": "",
                        "VS_PU_DRIVEWAY_SURFACE_MATERIAL": "",
                        "VS_PU_PARKING_SPACE_ASSIGNMENT": "",
                        "VS_PU_STORAGE_TYPE_DETAIL": "Attached",
                        "VS_PU_CAR_STORAGE_TYPE": "Garage"
                    },
                    {
                        "VS_CAR_STORAGE": "Driveway | 5 | Brick",
                        "VS_PU_STORAGE_NUMBER_SPACES": "5",
                        "VS_PU_STORAGE_SPACE_SQUARE_FEET": "",
                        "VS_PU_CAR_STORAGE_YES": "",
                        "VS_PU_CAR_STORAGE_NO": "",
                        "VS_PU_DRIVEWAY_SURFACE_MATERIAL": "Brick",
                        "VS_PU_PARKING_SPACE_ASSIGNMENT": "",
                        "VS_PU_STORAGE_TYPE_DETAIL": "",
                        "VS_PU_CAR_STORAGE_TYPE": "Driveway"
                    }
                ],
                "Amenities": [
                    {
                        "AmenityCategory": [
                            {
                                "SPA_AMENITY_CATEGORY": "Patio | Concrete | 230",
                                "PU_SPA_AMENITY_CATEGORY": "Patio",
                                "PU_SPA_AMENITY_TYPE": "Patio",
                                "PU_SPA_AMENITY_MATERIAL": "Concrete",
                                "PU_SPA_AMENITY_TOTALNUM": "",
                                "PU_SPA_AMENITY_DETAIL_AREA": "230",
                                "PU_SPA_AMENITY_DETAIL_AREA_UNIT": "",
                                "PU_SPA_AMENITY_DETAIL_FEATURE": ""
                            },
                            {
                                "SPA_AMENITY_CATEGORY": "Indoor Fireplace | 1 Story | 1",
                                "PU_SPA_AMENITY_CATEGORY": "Indoor Fireplace",
                                "PU_SPA_AMENITY_TYPE": "Indoor Fireplace",
                                "PU_SPA_AMENITY_MATERIAL": "1 Story",
                                "PU_SPA_AMENITY_TOTALNUM": "1",
                                "PU_SPA_AMENITY_DETAIL_AREA": "",
                                "PU_SPA_AMENITY_DETAIL_AREA_UNIT": "",
                                "PU_SPA_AMENITY_DETAIL_FEATURE": ""
                            }
                        ]
                    }
                ],
                "Outbuildings": [
                    {
                        "OUTBUILDING_TYPE": "Barn",
                        "CONSIDERED_REAL_PROP": "",
                        "TOTAL_AREA_FINISHED": "",
                        "TOTAL_AREA_UNFINISHED": "",
                        "HEATING_FLATTENED": "",
                        "HEATING_YES": "",
                        "HEATING_NO": "",
                        "MECH_HEAT_FLATTENED": "",
                        "MECH_HEAT_SYSTEM": "",
                        "MECH_HEAT_DETAIL": "",
                        "MECH_COOL_SYSTEM": "",
                        "OTH_MECH_SYSTEMS": "",
                        "COOLING_FLATTENED": "",
                        "COOLING_YES": "",
                        "COOLING_NO": ""
                    },
                    {
                        "OUTBUILDING_TYPE": "Boathouse",
                        "CONSIDERED_REAL_PROP": "",
                        "TOTAL_AREA_FINISHED": "",
                        "TOTAL_AREA_UNFINISHED": "",
                        "HEATING_FLATTENED": "",
                        "HEATING_YES": "",
                        "HEATING_NO": "",
                        "MECH_HEAT_FLATTENED": "",
                        "MECH_HEAT_SYSTEM": "",
                        "MECH_HEAT_DETAIL": "",
                        "MECH_COOL_SYSTEM": "",
                        "OTH_MECH_SYSTEMS": "",
                        "COOLING_FLATTENED": "",
                        "COOLING_YES": "",
                        "COOLING_NO": ""
                    },
                    {
                        "OUTBUILDING_TYPE": "Greenhouse",
                        "CONSIDERED_REAL_PROP": "",
                        "TOTAL_AREA_FINISHED": "",
                        "TOTAL_AREA_UNFINISHED": "",
                        "HEATING_FLATTENED": "",
                        "HEATING_YES": "",
                        "HEATING_NO": "",
                        "MECH_HEAT_FLATTENED": "",
                        "MECH_HEAT_SYSTEM": "",
                        "MECH_HEAT_DETAIL": "",
                        "MECH_COOL_SYSTEM": "",
                        "OTH_MECH_SYSTEMS": "",
                        "COOLING_FLATTENED": "",
                        "COOLING_YES": "",
                        "COOLING_NO": ""
                    }
                ],
                "SC_CONTRACT_SALES_PRICE": "",
                "SC_CONTRACT_DATE": "",
                "SC_TRANSFER_TERMS": "",
                "SC_CONCESSIONS_FLATTENED": "",
                "SC_KWN_CONCESSIONS": "",
                "SC_TOTAL_CONCESSIONS": "",
                "FO_FUNCTIONAL_ISSUE_TYPE": ""
            }
        }

        return data;
}

function DBBestCompPayload(): any {
    const data = {
    "records": 2,
    "yourCount": 0,
    "peerCount": 2,
    "reportUseCount": 1,
    "isPeerComp": true,
    "sourceData": {
        "COMP_PHOTO": "",
        "AD_ADDR1": "539 Shirley LN NE",
        "DB_UNITNO": "",
        "DB_CITY": "Piedmont",
        "DB_STATE": "OK",
        "DB_ZIP": "73078",
        "SC_SOURCE1": "MLS",
        "PU_DATA_SOURCE": "MLS",
        "PU_DATA_SOURCE_ASSESSOR_ID": "MLS",
        "PU_DATA_SOURCE_MLS_NUM": "1",
        "PROX1": "0.5 miles NW",
        "PU_DISTANCE": "0.5",
        "PU_MILES": "0.5",
        "PU_KILOMETERS": "0.5",
        "PU_DIRECTION": "Standard Direction",
        "LP_PRICE": "350000",
        "LP_STATUS": "Closed",
        "CONT_PRICE": "350000",
        "PU_CONT_PRICE_KNOWN": "350000",
        "PU_CONT_PRICE": "350000",
        "PR_SALEPR1": "350000",
        "TRANSFER_TERMS": "1850",
        "DP_FINTYP1": "Conventional",
        "EX_CONCAMT": "350000",
        "PU_CONC_PRESENT": "Standard Concessions Present",
        "PU_CONC_AMOUNT": "Standard Concession Amount",
        "CONT_DATE": "2026-04-15",
        "PU_CONT_DATE_KNOWN": "2026-04-15",
        "PU_CONT_DATE": "2026-04-15",
        "DT_SALTIM1": "2026-04-15",
        "EX_DOM": "33",
        "SP_TO_LP_RATIO": "350000",
        "ATT_DET": "Detached",
        "PROP_APPRAISER_RIGHTS": "Standard Property Rights Appraised",
        "ANNUAL_GRND_RENT": "Standard Annual Ground Rent",
        "NATIVE_AM_LANDS": "Standard Native American Lands",
        "PU_NATIVE_AM_LANDS_YES": "1",
        "PU_NATIVE_AM_LANDS_NO": "0",
        "PU_NATIVE_AM_LANDS_TYPE": "Standard Native American Lands Type",
        "ALL_RIGHTS_INCLUDED": "Standard All Rights Included",
        "RIGHTS_NOT_INCLUDED": "Standard Rights Not Included",
        "SAME_BLDR_AS_SUBJECT": "Standard Same Builder as Subject",
        "GI_BLANK": "",
        "PROJ_NAME": "Standard Project Name ",
        "PU_PROJECT_NAME": "RES-WAWONA DRIVE",
        "PU_SAME_PROJECT_AS_SUBJECT": "Standard Same Project",
        "PROJ_MONTHLY_FEE": "Standard Monthly Fee",
        "PROJ_AMENITIES": "None",
        "PROJ_SPECIAL_ASSESSMENTS": "Standard Special Assessments",
        "SITE_PROJECT_TYPE": "Standard Project Type",
        "SITE_OWNED_IN_COMMON": "Standard Site Owned In Common",
        "ST_SITSIZE": "0.25",
        "MARKETAREA": "Oakridge Estates",
        "SITE_ZONE_COMPLIANCE": "Standard Zoning Compliance",
        "SITE_HAZARD_ZONE": "Standard Hazard Zone",
        "SITE_PRIMARY_ACCESS": "Standard Primary Access",
        "SiteStreetType": [
            {
                "SITE_STREET_TYPE": "Cul-de-sac | Paved",
                "PU_SITE_STREET_TYPE": "Cul-de-sac",
                "PU_SITE_STREET_SURFACE": "Paved"
            },
            {
                "SITE_STREET_TYPE": "Dead End | Paved",
                "PU_SITE_STREET_TYPE": "Dead End",
                "PU_SITE_STREET_SURFACE": "Paved"
            }
        ],
        "SITE_PROP_RESTRICT": "Standard Property Restriction",
        "SITE_EASEMENT": "Standard Easement",
        "SITE_TOPOGRAPHY": "Standard Topography",
        "SiteDrainage": [
            {
                "SITE_DRAINAGE": "Standard Drainage"
            },
            {
                "SITE_DRAINAGE": "Complex Drainage"
            }
        ],
        "SITE_CHARACTERISTICS": "Standard Site Characteristics",
        "SITE_INFLUENCE": "Standard Site Influence",
        "PU_SITE_INFLUENCE": "Standard Site Influence",
        "PU_SITE_INFLUENCE_PRIVATE_ACCESS": "Standard Site Influence Private Access",
        "PU_SITE_INFLUENCE_WATER_TYPE": "Standard Site Influence Water Type",
        "SITE_ENV_COND": "C3",
        "SiteViews": [
            {
                "ST_VIEW": "Creek | Seasonal",
                "PU_ST_VIEW": "Creek",
                "PU_ST_RANGE": "Seasonal"
            },
            {
                "ST_VIEW": "Marsh | Partial",
                "PU_ST_VIEW": "Marsh",
                "PU_ST_RANGE": "Partial"
            }
        ],
        "SITE_BLANK": "",
        "Dwellings": [
            {
                "YR_BLT": "1970 | No",
                "PU_YR_BLT": "1970",
                "PU_YR_BLT_EST": "No",
                "DWELL_DESIGN": "Colonial",
                "PU_STRUCTURE_DESIGN": "Colonial",
                "SF_GLA": "1850",
                "SF_FINISHED_AREA": "1850",
                "DWELL_TH_BACKTOBACK": "Standard Townhouse Back to Back",
                "PU_DWELL_TH_BACKTOBACK": "Standard Townhouse Back to Back",
                "DWELL_TH_LOC": "Standard Townhouse Location",
                "PU_DWELL_TH_LOC": "Standard Townhouse Location",
                "DWELL_CONST_METHOD": "Stick Built",
                "PU_DWELL_CONST_METHOD": "Stick Built",
                "DWELL_MANFCT_HOME_WIDTH": "12-34-567-890",
                "PU_DWELL_MANFCT_HOME_WIDTH": "12-34-567-890",
                "DWELL_STYLE": "Colonial",
                "PU_DWELL_STYLE": "Colonial",
                "DWELL_TOTAL_VOLUME": "1850",
                "DWELL_WINDOW_AREA": "1850",
                "DWELL_FUNC_ISSUES": "Standard Functional Issues",
                "PU_DWELL_FUNC_ISSUES": "Standard Functional Issues",
                "DWELL_DISASTER_MIT": "Standard Disaster Mitigation",
                "PU_DWELL_DISASTER_MIT": "Standard Disaster Mitigation",
                "Heating": [
                    {
                        "DWELL_HEAT": "CENTRAL",
                        "PU_DWELL_HEAT_SYSTEM": "CENTRAL",
                        "PU_DWELL_HEAT_DETAIL": ""
                    }
                ],
                "Cooling": [
                    {
                        "DWELL_COOL": "Centralized",
                        "PU_DWELL_COOL": "Centralized"
                    }
                ],
                "DWELL_OTHR1_BLANK": "",
                "Units": [
                    {
                        "UNIT_ID": "Apt 4B",
                        "UNITS_IS_AN_ADU": "Apt 4B",
                        "LOC_ADU": "Standard Location of ADU",
                        "PU_LOC_ADU_TYPE": "Standard Location Type",
                        "PU_LOC_ADU_DESC": "Standard Location Description",
                        "FLOOR_NUM": "1",
                        "CORNER_UNIT": "Apt 4B",
                        "LEVELS": "Apt 4B",
                        "BEDS": "5",
                        "BATHS": "3",
                        "PU_FULL_BATHS": "3",
                        "PU_HALF_BATHS": "2.5",
                        "UNITS_SF_GLA": "1850",
                        "UNITS_SF_GLA_NONSTD": "1850",
                        "UNITS_SF_GLA_UNFIN": "1850",
                        "UNITS_SF_GLA_BELOW_GRD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_NONSTD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_UNFIN": "1850",
                        "DISABILITY_FEATURES": "Standard Features for Individuals w/Disabilities",
                        "UNITS_BLANK": ""
                    },
                    {
                        "UNIT_ID": "Apt 5B",
                        "UNITS_IS_AN_ADU": "5B",
                        "LOC_ADU": "Standard Location of ADU",
                        "PU_LOC_ADU_TYPE": "Standard Location Type",
                        "PU_LOC_ADU_DESC": "Standard Location Description",
                        "FLOOR_NUM": "1",
                        "CORNER_UNIT": "Apt 5B",
                        "LEVELS": "5B",
                        "BEDS": "5",
                        "BATHS": "3",
                        "PU_FULL_BATHS": "3",
                        "PU_HALF_BATHS": "2.5",
                        "UNITS_SF_GLA": "1850",
                        "UNITS_SF_GLA_NONSTD": "1850",
                        "UNITS_SF_GLA_UNFIN": "1850",
                        "UNITS_SF_GLA_BELOW_GRD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_NONSTD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_UNFIN": "1850",
                        "DISABILITY_FEATURES": "Standard Features for Individuals w/Disabilities",
                        "UNITS_BLANK": ""
                    },
                    {
                        "UNIT_ID": "Apt 6B",
                        "UNITS_IS_AN_ADU": "Apt 6B",
                        "LOC_ADU": "Standard Location of ADU",
                        "PU_LOC_ADU_TYPE": "Standard Location Type",
                        "PU_LOC_ADU_DESC": "Standard Location Description",
                        "FLOOR_NUM": "1",
                        "CORNER_UNIT": "Apt 6B",
                        "LEVELS": "6B",
                        "BEDS": "5",
                        "BATHS": "3",
                        "PU_FULL_BATHS": "3",
                        "PU_HALF_BATHS": "2.5",
                        "UNITS_SF_GLA": "1850",
                        "UNITS_SF_GLA_NONSTD": "1850",
                        "UNITS_SF_GLA_UNFIN": "1850",
                        "UNITS_SF_GLA_BELOW_GRD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_NONSTD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_UNFIN": "1850",
                        "DISABILITY_FEATURES": "Standard Features for Individuals w/Disabilities",
                        "UNITS_BLANK": ""
                    }
                ]
            },
            {
                "YR_BLT": "1971 | No",
                "PU_YR_BLT": "1971",
                "PU_YR_BLT_EST": "No",
                "DWELL_DESIGN": "Colonial",
                "PU_STRUCTURE_DESIGN": "Colonial",
                "SF_GLA": "1850",
                "SF_FINISHED_AREA": "1850",
                "DWELL_TH_BACKTOBACK": "Standard Townhouse Back to Back",
                "PU_DWELL_TH_BACKTOBACK": "Standard Townhouse Back to Back",
                "DWELL_TH_LOC": "Standard Townhouse Location",
                "PU_DWELL_TH_LOC": "Standard Townhouse Location",
                "DWELL_CONST_METHOD": "Stick Built",
                "PU_DWELL_CONST_METHOD": "Stick Built",
                "DWELL_MANFCT_HOME_WIDTH": "12-34-567-890",
                "PU_DWELL_MANFCT_HOME_WIDTH": "12-34-567-890",
                "DWELL_STYLE": "Colonial",
                "PU_DWELL_STYLE": "Colonial",
                "DWELL_TOTAL_VOLUME": "1850",
                "DWELL_WINDOW_AREA": "1850",
                "DWELL_FUNC_ISSUES": "Standard Functional Issues",
                "PU_DWELL_FUNC_ISSUES": "Standard Functional Issues",
                "DWELL_DISASTER_MIT": "Standard Disaster Mitigation",
                "PU_DWELL_DISASTER_MIT": "Standard Disaster Mitigation",
                "Heating": [
                    {
                        "DWELL_HEAT": "CENTRAL",
                        "PU_DWELL_HEAT_SYSTEM": "CENTRAL",
                        "PU_DWELL_HEAT_DETAIL": ""
                    }
                ],
                "Cooling": [
                    {
                        "DWELL_COOL": "Centralized",
                        "PU_DWELL_COOL": "Centralized"
                    }
                ],
                "DWELL_OTHR1_BLANK": "",
                "Units": [
                    {
                        "UNIT_ID": "Apt 8B1",
                        "UNITS_IS_AN_ADU": "Apt 8B1",
                        "LOC_ADU": "Standard Location of ADU",
                        "PU_LOC_ADU_TYPE": "Standard Location Type",
                        "PU_LOC_ADU_DESC": "Standard Location Description",
                        "FLOOR_NUM": "1",
                        "CORNER_UNIT": "Apt 8B1",
                        "LEVELS": "Apt 8B1",
                        "BEDS": "5",
                        "BATHS": "3",
                        "PU_FULL_BATHS": "3",
                        "PU_HALF_BATHS": "2.5",
                        "UNITS_SF_GLA": "1850",
                        "UNITS_SF_GLA_NONSTD": "1850",
                        "UNITS_SF_GLA_UNFIN": "1850",
                        "UNITS_SF_GLA_BELOW_GRD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_NONSTD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_UNFIN": "1850",
                        "DISABILITY_FEATURES": "Standard Features for Individuals w/Disabilities",
                        "UNITS_BLANK": ""
                    },
                    {
                        "UNIT_ID": "Apt 9C1",
                        "UNITS_IS_AN_ADU": "Apt 9C1",
                        "LOC_ADU": "Standard Location of ADU",
                        "PU_LOC_ADU_TYPE": "Standard Location Type",
                        "PU_LOC_ADU_DESC": "Standard Location Description",
                        "FLOOR_NUM": "1",
                        "CORNER_UNIT": "Apt 9C1",
                        "LEVELS": "Apt 9C1",
                        "BEDS": "5",
                        "BATHS": "3",
                        "PU_FULL_BATHS": "3",
                        "PU_HALF_BATHS": "2.5",
                        "UNITS_SF_GLA": "1850",
                        "UNITS_SF_GLA_NONSTD": "1850",
                        "UNITS_SF_GLA_UNFIN": "1850",
                        "UNITS_SF_GLA_BELOW_GRD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_NONSTD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_UNFIN": "1850",
                        "DISABILITY_FEATURES": "Standard Features for Individuals w/Disabilities",
                        "UNITS_BLANK": ""
                    },
                ]
            }
        ],
        "WaterFrontages": [
            {
                "WATER_FRONTAGE": "Creek | Deer Creek | Shallow Water",
                "PU_WATER_FRONTAGE_TYPE": "Creek",
                "PU_WATER_FRONTAGE_NAME": "Deer Creek",
                "PU_WATER_FRONTAGE_ACCESS_DEPTH": "Shallow Water"
            },
            {
                "WATER_FRONTAGE": "Marsh | Non-Navigable",
                "PU_WATER_FRONTAGE_TYPE": "Marsh",
                "PU_WATER_FRONTAGE_NAME": "",
                "PU_WATER_FRONTAGE_ACCESS_DEPTH": "Non-Navigable"
            }
        ],
        "WATER_FRONTAGE_FEAT": "147233",
        "WATER_RIGHT_BLD": "Standard Right to Build",
        "WATER_LINEAR_MEASURE": "Standard Total Linear Measurement",
        "PU_WATER_LINEAR_MEASURE": "Standard Water Linear Measure",
        "PU_WATER_LINEAR_MEASURE_FEET": "Standard Water Linear Measure Feet",
        "PU_WATER_LINEAR_MEASURE_METERS": "Standard Water Linear Measure Meters",
        "GREEN_RENEW_ENERGY_ONENT": "Standard Renewable Energy Component",
        "BuildingCertifications": [
            {
                "GREEN_BUILD_CERT": "Certification 1 | 19%",
                "PU_GREEN_BUILD_CERT_DESC": "Certification",
                "PU_GREEN_BUILD_CERT_RATE": "19%"
            },
            {
                "GREEN_BUILD_CERT": "Certification 2 | 27%",
                "PU_GREEN_BUILD_CERT_DESC": "Certification 2",
                "PU_GREEN_BUILD_CERT_RATE": "27%"
            }
        ],
        "EfficiencyRatings": [
            {
                "GREEN_EFF_RATING": "C- | 70",
                "PU_GREEN_EFF_RATING": "C-",
                "PU_GREEN_EFF_SCORE": "70"
            },
            {
                "GREEN_EFF_RATING": "A | 93",
                "PU_GREEN_EFF_RATING": "A",
                "PU_GREEN_EFF_SCORE": "93"
            }
        ],
        "ExteriorQualities" : [
            {
                "EXT_QUAL_STRUCTURE_ID": "Q3",
                "EXT_QUAL_QUALITY": "Q3",
                "EXT_QUAL_EXT_WALLS_TRIM": "Standard / Typical",
                "EXT_QUAL_FOUNDATION": "Standard / Typical",
                "EXT_QUAL_ROOF": "Standard / Typical",
                "EXT_QUAL_WINDOWS": "Q3",
                "BLExteriorQualities" : [
                    {
                        "EXT_QUAL_BLANK_LABEL": "",
                        "EXT_QUAL_BLANK": "",
                    }
                ],
            },
            {
                "EXT_QUAL_STRUCTURE_ID": "Q3",
                "EXT_QUAL_QUALITY": "Q3",
                "EXT_QUAL_EXT_WALLS_TRIM": "Standard / Typical",
                "EXT_QUAL_FOUNDATION": "Standard / Typical",
                "EXT_QUAL_ROOF": "Standard / Typical",
                "EXT_QUAL_WINDOWS": "Q3",
                "BLExteriorQualities" : [
                    {
                        "EXT_QUAL_BLANK_LABEL": "",
                        "EXT_QUAL_BLANK": "",
                    }
                ],
            },
        ],
        "ExteriorConditions" : [
            {
                "EXT_COND_CONDITION": "A3",
                "EXT_COND_WALLS_TRIM": "Standard / Typical",
                "EXT_COND_FOUNDATION": "Standard / Typical",
                "EXT_COND_ROOF": "Standard / Typical",
                "PU_EXT_COND_ROOF_OBSERVABLE": "Standard / Typical",
                "PU_EXT_COND_ROOF_STATUS": "Standard / Typical",
                "EXT_COND_WINDOWS": "A3",
                "BLExteriorConditions" : [
                    {
                        "EXT_COND_BLANK_LABEL": "",
                        "EXT_COND_BLANK": "",
                    }
                ],
            },
            {
                "EXT_COND_CONDITION": "B3",
                "EXT_COND_WALLS_TRIM": "Standard / Typical",
                "EXT_COND_FOUNDATION": "Standard / Typical",
                "EXT_COND_ROOF": "Standard / Typical",
                "PU_EXT_COND_ROOF_OBSERVABLE": "Standard / Typical",
                "PU_EXT_COND_ROOF_STATUS": "Standard / Typical",
                "EXT_COND_WINDOWS": "B3",
                "BLExteriorConditions" : [
                    {
                        "EXT_COND_BLANK_LABEL": "",
                        "EXT_COND_BLANK": "",
                    }
                ],
            },
        ],
        "InteriorQualities" : [
            {
                "INT_QUAL_STRUCTURE_ID": "Apt 4B",
                "INT_QUAL_QUALITY": "Q3",
                "INT_QUAL_KITCHEN": "Q3",
                "INT_QUAL_BATHS": "2.5",
                "INT_QUAL_FLOORS": "Q3",
                "INT_QUAL_WALLS_CEILINGS": "Standard / Typical",
                "INT_QUAL_BLANK": "",
                "BLInteriorQuality" : [
                    {
                        "INT_QUAL_BLANK_LABEL": "",
                        "INT_QUAL_BLANK": "",
                    }
                ],
            },
            {
                "INT_QUAL_STRUCTURE_ID": "Apt 4C",
                "INT_QUAL_QUALITY": "Q3",
                "INT_QUAL_KITCHEN": "Q3",
                "INT_QUAL_BATHS": "2.5",
                "INT_QUAL_FLOORS": "Q3",
                "INT_QUAL_WALLS_CEILINGS": "Standard / Typical",
                "INT_QUAL_BLANK": "",
                "BLInteriorQuality" : [
                    {
                        "INT_QUAL_BLANK_LABEL": "",
                        "INT_QUAL_BLANK": "",
                    }
                ],
            }
        ],
        "InteriorConditions" : [
            {
                "INT_COND_CONDITION": "C3",
                "INT_COND_KITCHEN": "C3",
                "INT_COND_BATHS": "2.5",
                "INT_COND_FLOORS": "C3",
                "INT_COND_WALLS_CEILINGS": "Standard / Typical",
                "BLInteriorConditions" : [
                    {
                        "INT_COND_BLANK_LABEL": "",
                        "INT_COND_BLANK": "",
                    }
                ],
            },
            {
                "INT_COND_CONDITION": "K3",
                "INT_COND_KITCHEN": "K3",
                "INT_COND_BATHS": "2.5",
                "INT_COND_FLOORS": "K3",
                "INT_COND_WALLS_CEILINGS": "Standard / Typical",
                "BLInteriorConditions" : [
                    {
                        "INT_COND_BLANK_LABEL": "",
                        "INT_COND_BLANK": "",
                    }
                ],
            }
        ],
        "ADUQualities" : [
            {
                "ADU_LOCATION": "Standard ADU Location 1",
                "ADU_QUAL_QUALITY": "Q3",
                "ADU_QUAL_KITCHEN": "Q3",
                "INT_ADU_COND_BATHS": "2.5",
                "ADU_QUAL_FLOORS": "Q3",
                "ADU_QUAL_WALLS_CEILINGS": "Standard / Typical",
                "ADU_QUAL_BLANK": "",
                "BLADUQualities" : [
                    {
                        "ADU_QUAL_BLANK_LABEL": "",
                        "ADU_QUAL_BLANK": "",
                    }
                ]
            },
            {
                "ADU_LOCATION": "Standard ADU Location 2",
                "ADU_QUAL_QUALITY": "Q3",
                "ADU_QUAL_KITCHEN": "Q3",
                "INT_ADU_COND_BATHS": "2.5",
                "ADU_QUAL_FLOORS": "Q3",
                "ADU_QUAL_WALLS_CEILINGS": "Standard / Typical",
                "ADU_QUAL_BLANK": "",
                "BLADUQualities" : [
                    {
                        "ADU_QUAL_BLANK_LABEL": "",
                        "ADU_QUAL_BLANK": "",
                    }
                ]
            }
        ],
        "ADUConditions" : [
            {
                "ADU_COND_CONDITION": "C3",
                "ADU_COND_KITCHEN": "C3",
                "ADU_COND_BATHS": "2.5",
                "ADU_COND_FLOORS": "C3",
                "ADU_COND_WALLS_CEILINGS": "Standard / Typical",
                "ADU_COND_BLANK": "",
                "BLADUConditions" : [
                    {
                        "ADU_COND_BLANK_LABEL": "",
                        "ADU_COND_BLANK": "",
                    }
                ],
            },
            {
                "ADU_COND_CONDITION": "D3",
                "ADU_COND_KITCHEN": "D3",
                "ADU_COND_BATHS": "2.5",
                "ADU_COND_FLOORS": "D3",
                "ADU_COND_WALLS_CEILINGS": "Standard / Typical",
                "ADU_COND_BLANK": "",
                "BLADUConditions" : [
                    {
                        "ADU_COND_BLANK_LABEL": "",
                        "ADU_COND_BLANK": "",
                    }
                ],
            }
        ],
        "QUALITY": "Q3",
        "CONDITION": "C3",
        "Amenities": [
            {
                "OutdoorAccessories": [
                    {
                        "AMENITY_OUTDOOR_ACCESSORIES": "Outdoor Firpit | 1",
                        "PU_AMENITY_OUTDOOR_ACCESSORIES": "Outdoor Firpit",
                        "PU_AMENITY_OUTDOOR_ACCESSORIES_NUM": "1"
                    }
                ],
                "OutdoorLiving": [
                    {
                        "AMENITY_OUTDOOR_LIVING": "Deck | 3 | 96",
                        "PU_AMENITY_OUTDOOR_LIVING": "Deck"
                    },
                    {
                        "AMENITY_OUTDOOR_LIVING": "Porch | 384",
                        "PU_AMENITY_OUTDOOR_LIVING": "Porch"
                    }
                ],
                "WaterFeatures": [
                    {
                        "AMENITY_WATER_FEATURES": "Outdoor Shower | 1 | 1",
                        "PU_AMENITY_WATER_FEATURE": "Outdoor Shower",
                        "PU_AMENITY_WATER_FEATURE_DETAIL": "1",
                        "PU_AMENITY_WATER_FEATURE_NUM": "1"
                    }
                ],
                "WholeHome": [
                    {
                        "AMENITY_WHOLE_HOME": "Elevator | 1",
                        "PU_AMENITY_WHOLE_HOME": "Elevator",
                        "PU_AMENITY_WHOLE_HOME_NUM": "1"
                    }
                ],
                "Miscellaneous": [
                    {
                        "AMENITY_MISC": "Indoor Fireplace | 1",
                        "PU_AMENITY_MISC": "Indoor Fireplace",
                        "PU_AMENITY_MISC_NUM": "1"
                    }
                ]
            }
        ],
        "VehicleStorage": [
            {
                "VEHICLE_STORAGE": "Garage | Attached | 1165",
                "PU_VEHICLE_STORAGE": "Garage",
                "PU_VEHICLE_STORAGE_SPACES": "",
                "PU_VEHICLE_STORAGE_DETAILS": "Attached",
                "PU_VEHICLE_STORAGE_SQFT": "1165",
                "BL_VEHICLE_STORAGE": ""
            },
            {
                "VEHICLE_STORAGE": "Carport | 2 | Attached | 1170",
                "PU_VEHICLE_STORAGE": "Carport",
                "PU_VEHICLE_STORAGE_SPACES": "2",
                "PU_VEHICLE_STORAGE_DETAILS": "Attached",
                "PU_VEHICLE_STORAGE_SQFT": "1170",
                "BL_VEHICLE_STORAGE": ""
            },
            {
                "VEHICLE_STORAGE": "Driveway | 4 | Asphalt",
                "PU_VEHICLE_STORAGE": "Driveway",
                "PU_VEHICLE_STORAGE_SPACES": "4",
                "PU_VEHICLE_STORAGE_DETAILS": "Asphalt",
                "PU_VEHICLE_STORAGE_SQFT": "",
                "BL_VEHICLE_STORAGE": ""
            }
        ],
        "Outbuildings": [
            {
                "OUTBUILDING_TYPE": "Manufactured Home",
                "OUTBUILDING_REAL_PROPERTY": "Yes",
                "OUTBUILDING_BUILDING_AREA": "5000",
                "OUTBUILDING_FINISHED_AREA": "5000",
                "OUTBUILDING_UNFINISHED_AREA": "0",
                "OUTBUILDING_STRUCTURE_VOLUME": "4000",
                "OUTBUILDING_BATHS_FULL": "1",
                "OUTBUILDING_BATHS_HALF": "2",
                "OUTBUILDING_KITCHENS": "1",
                "OUTBUILDING_HEATING": "Yes",
                "OUTBUILDING_COOLING": "Yes",
                "OutbuildingUtilities": [
                    {
                        "OUTBUILDING_UTILITIES": "Electricity"
                    },
                    {
                        "OUTBUILDING_UTILITIES": "Water"
                    }
                ],
                "BLOutbuilding": [ // CURRENTLY NOT USED 
                    {
                        "BL_OUTBUILDING_BLANK": "",
                        "BL_OUTBUILDING": ""
                    }
                ]
            },
            {
                "OUTBUILDING_TYPE": "Barn",
                "OUTBUILDING_REAL_PROPERTY": "Yes",
                "OUTBUILDING_BUILDING_AREA": "5000",
                "OUTBUILDING_FINISHED_AREA": "5000",
                "OUTBUILDING_UNFINISHED_AREA": "0",
                "OUTBUILDING_STRUCTURE_VOLUME": "4000",
                "OUTBUILDING_BATHS_FULL": "1",
                "OUTBUILDING_BATHS_HALF": "2",
                "OUTBUILDING_KITCHENS": "1",
                "OUTBUILDING_HEATING": "Yes",
                "OUTBUILDING_COOLING": "Yes",
                "OutbuildingUtilities": [
                    {
                        "OUTBUILDING_UTILITIES": "Sewer"
                    }
                ],
                "BLOutbuilding": [ // CURRENTLY NOT USED 
                    {
                        "BL_OUTBUILDING_BLANK": "",
                        "BL_OUTBUILDING": ""
                    }
                ]
            },
        ],
        "TransferHistories": [
            {
                "TRANSFER_HISTORY_PRESENT": "1950",
                "TRANSFER_HISTORY_TERMS": "1950",
                "TRANSFER_HISTORY_DATE": "2026-04-15",
                "TRANSFER_HISTORY_AMOUNT": "50000",
                "DFE_TRANSFER_HISTORY_AMOUNT_VALUE": "50000",
                "DFE_TRANSFER_HISTORY_AMOUNT_REASON": "1950",
                "TRANSFER_HISTORY_SOURCE": "1950",
            },
            {
                "TRANSFER_HISTORY_PRESENT": "2000",
                "TRANSFER_HISTORY_TERMS": "2000",
                "TRANSFER_HISTORY_DATE": "2026-04-15",
                "TRANSFER_HISTORY_AMOUNT": "150000",
                "DFE_TRANSFER_HISTORY_AMOUNT_VALUE": "150000",
                "DFE_TRANSFER_HISTORY_AMOUNT_REASON": "2000",
                "TRANSFER_HISTORY_SOURCE": "2000",
            },
            {
                "TRANSFER_HISTORY_PRESENT": "2000",
                "TRANSFER_HISTORY_TERMS": "2000",
                "TRANSFER_HISTORY_DATE": "2026-04-15",
                "TRANSFER_HISTORY_AMOUNT": "150000",
                "DFE_TRANSFER_HISTORY_AMOUNT_VALUE": "150000",
                "DFE_TRANSFER_HISTORY_AMOUNT_REASON": "2000",
                "TRANSFER_HISTORY_SOURCE": "2000",
            }
        ]
    }
    }

    return data;
}


function PRSubjectPayload(): any {
    const data = {
        "SUB_PHOTO": "",
        "SUBPROPADDRESS": "539 Shirley LN NE",
        "SUBUNITNO": "",
        "SUBCITY": "Piedmont",
        "SUBSTATE": "OK",
        "SUBZIP": "73078",
        "SUBCOUNTY": "Oklahoma",
        "SUBPROJNAME": "RES-WAWONA DRIVE",
        "ATTACHMENT_TYPE": "Detached",
        "ProjectType": {
            "PROJECT_TYPE_FLATTENED": "X",
            "PUD_YES": "X",
            "PUD_NO": "",
            "CONDO_YES": "",
            "CONDO_NO": "",
            "COOP_YES": "",
            "COOP_NO": "",
            "CONDOP_YES": "",
            "CONDOP_NO": ""
        },
        "NativeAmericanLands": {
            "NATAMLAND_FLATTENED": "X",
            "NATAMLAND_YES": "X",
            "NATAMLAND_NO": ""
        },
        "SiteOwnedInCommon": {
            "SITE_OWNED_IN_COMMON_FLATTENED": "X",
            "SITOWNEDCOMMON_YES": "X",
            "SITOWNEDCOMMON_NO": ""
        },
        "HomeownerResponsible": {
            "HORESPMAINT_FLATTENED": "X",
            "HORESPMAINT_YES": "X",
            "HORESPMAINT_NO": ""
        },
        "NewConstruction": {
            "NEWCONST_FLATTENED": "X",
            "NEWCONST_YES": "X",
            "NEWCONST_NO": ""
        },
        "PROPRIGHTSAPPR": "Fee Simple",
        "GROUND_RENTAL_ANNUAL_AMOUNT": "1200",
        "ALL_RIGHTS_INCLUDED": "No",
        "RIGHTS_NOT_INCLUDED": "Air Right",
        "SUBLEGALDESCRIP": "PT LL 48 10/4",
        "Owners": [
            {
                "SUBCUROWNER": "JOHN CROWE",
                "SUBCUROWNER_TYPE": "Individual",
                "SUBCUROWNER_FIRST_NAME": "JOHN",
                "SUBCUROWNER_MIDDLE_NAME": "",
                "SUBCUROWNER_LAST_NAME": "CROWE",
                "SUBCUROWNER_SUFFIX_NAME": "",
                "SUBCUROWNER_FULL_NAME": "JOHN CROWE",
            },
            {
                "SUBCUROWNER": "BRENDA CROWE",
                "SUBCUROWNER_TYPE": "LegalEntity",
                "SUBCUROWNER_FIRST_NAME": "",
                "SUBCUROWNER_MIDDLE_NAME": "",
                "SUBCUROWNER_LAST_NAME": "",
                "SUBCUROWNER_SUFFIX_NAME": "",
                "SUBCUROWNER_FULL_NAME": "BRENDA CROWE",
            }
        ],
        "LATITUDE": "34.962639",
        "LONGITUDE": "-85.423553",
        "SITSITEAREA": "147233",
        "NUMPARCELS": "1",
        "AssessorParcels": [
            {
                "APN": "0520002000 | 052-00-020-00 | Land with Improvement | Data Aggregator",
                "PU_APN": "0520002000",
                "PU_ALT_APN": "052-00-020-00",
                "PU_APN_DESC": "Land with Improvement",
                "PU_SOURCE_APN": "Data Aggregator",
            },
            {
                "APN": "05200033333 | 052-00-020-00 | Land with Improvement | Data Aggregator",
                "PU_APN": "05200033333",
                "PU_ALT_APN": "052-00-020-00",
                "PU_APN_DESC": "Land with Improvement",
                "PU_SOURCE_APN": "Data Aggregator",
            }
        ],
        "PARCEL_SIZE": "147233",
        "SIT_COMPLIANCE": "Legal",
        "SIT_PRIMACCESS": "Public Street",
        "SiteStreetType": [
            {
                "SIT_STREET_TYPE_SURFACE": "Cul-de-sac | Paved",
                "PU_STREET_TYPE": "Cul-de-sac",
                "PU_SURFACE_TYPE": "Paved"
            },
            {
                "SIT_STREET_TYPE_SURFACE": "Dead End | Paved",
                "PU_STREET_TYPE": "Dead End",
                "PU_SURFACE_TYPE": "Paved"
            }
        ],
        "SiteInfluence": [
            {
                "SIT_INFL_FLATTENED": "1 | Water Frontage | No",
                "SIT_INFL_INFL": "1",
                "PU_SITE_INFL_WTR_DTL_TYPE": "Water Frontage",
                "PU_SITE_INFL_WTR_DTL_PRIV_ACCESS": "No"
            },
            {
                "SIT_INFL_FLATTENED": "2 | Water Frontage | No",
                "SIT_INFL_INFL": "2",
                "PU_SITE_INFL_WTR_DTL_TYPE": "Water Frontage",
                "PU_SITE_INFL_WTR_DTL_PRIV_ACCESS": "No"
            }
        ],
        "ViewImpairment": [
            {
                "SIT_VWIMP_VIEW_FLATTENED": "test 1 | 12 | 123",
                "SIT_VWIMP_VIEW": "test 1",
                "SIT_VWIMP_RNGVW": "12",
                "SIT_VWIMP_IMP": "123"
            },
            {
                "SIT_VWIMP_VIEW_FLATTENED": "test 2 | 12 | 123",
                "SIT_VWIMP_VIEW": "test 2",
                "SIT_VWIMP_RNGVW": "12",
                "SIT_VWIMP_IMP": "123"
            }
        ],
        "SIT_FEAT_HZRD_ZONE_DTL": "Hazrad test 1",
        "PropertyRestrictions": [
            {
                "SIT_FEAT_RSTRCTN_DTL": "Land Use"
            },
            {
                "SIT_FEAT_RSTRCTN_DTL": "Historic Preservation"
            }
        ],
        "Easements": [
            {
                "SIT_FEAT_EASEMENT_DTL": "Drainage"
            },
            {
                "SIT_FEAT_EASEMENT_DTL": "Conservation"
            }
        ],
        "Encroachments": [
            {
                "SIT_FEAT_ENCROACH_DTL": "Driveway (Subject Property Encroaching on Bordering Property)",
                "PU_SITE_FEAT_ENCROACH": "Driveway",
                "PU_SITE_FEAT_ENCROACH_BRD_ON_SUB": "",
                "PU_SITE_FEAT_ENCROACH_BRD_ON_ADJ": "Subject Property Encroaching on Bordering Property"
            },
            {
                "SIT_FEAT_ENCROACH_DTL": "Fence (Bordering Property Encroaching on Subject Property)",
                "PU_SITE_FEAT_ENCROACH": "Fence",
                "PU_SITE_FEAT_ENCROACH_BRD_ON_SUB": "Bordering Property Encroaching on Subject Property",
                "PU_SITE_FEAT_ENCROACH_BRD_ON_ADJ": "",
            }
        ],
        "SiteFeatures": [
            {
                "SIT_FEAT_SITCHAR_DTL": "Drainage | Improper Grading ",
                "PU_SITE_FEAT_SITCHAR": "Drainage",
                "PU_SITE_FEAT_SITCHAR_TOP_TYPE": "",
                "PU_SITE_FEAT_SITCHAR_DRAIN_RSN": "Improper Grading"
                
            },
            {
                "SIT_FEAT_SITCHAR_DTL": "Excess Land",
                "PU_SITE_FEAT_SITCHAR": "Excess Land",
                "PU_SITE_FEAT_SITCHAR_TOP_TYPE": "",
                "PU_SITE_FEAT_SITCHAR_DRAIN_RSN": ""
            },
            {
                "SIT_FEAT_SITCHAR_DTL": "Topography | Rocky",
                "PU_SITE_FEAT_SITCHAR": "Topography",
                "PU_SITE_FEAT_SITCHAR_TOP_TYPE": "Rocky",
                "PU_SITE_FEAT_SITCHAR_DRAIN_RSN": ""
            }
        ],
        "DM_MITIGATION_FEATURE": "Fire Resistant Decking",
        "RenewableEnergyComponents": [
            {
                "EE_RENEWABLES": "Solar | Owned | X",
                "PU_EE_RENEWABLE_TYPE": "Solar",
                "PU_EE_OWNER_TYPE": "Owned",
                "PU_EE_FINANCING_ARRANGEMENT_YES": "X",
                "PU_EE_FINANCING_ARRANGEMENT_NO": ""
            },
            {
                "EE_RENEWABLES": "Geothermal | Leased",
                "PU_EE_RENEWABLE_TYPE": "Geothermal",
                "PU_EE_OWNER_TYPE": "Leased",
                "PU_EE_FINANCING_ARRANGEMENT_YES": "",
                "PU_EE_FINANCING_ARRANGEMENT_NO": "X"
            }
        ],
        "BuildingCertifications": [
            {
                "EE_CERTS_ORGANIZATION_FLATTENED": "Building 1 | 2 | 2004 | 3.4 | 4.7",
                "EE_CERTS_ORGANIZATION": "Building 1 ",
                "EE_CERTS": "2",
                "EE_YEAR": "2004",
                "EE_VERSION": "3.4",
                "EE_RATING": "4.7"
            },
            {
                "EE_CERTS_ORGANIZATION_FLATTENED": "Building 2 | 2 | 2004 | 3.4 | 4.7",
                "EE_CERTS_ORGANIZATION": "Building 2 ",
                "EE_CERTS": "2",
                "EE_YEAR": "2004",
                "EE_VERSION": "3.4",
                "EE_RATING": "4.7"
            }
        ],
        "EfficiencyRatings": [
            {
                "EE_GREEN_EFF_FLATTENED": "Green 123 | 123 | 123",
                "EE_GREEN_EFF": "Green 123",
                "EE_GREEN_RATING": "123",
                "EE_GREEN_SCORE": "123"
            },
            {
                "EE_GREEN_EFF_FLATTENED": "Green 456 | 123 | 123",
                "EE_GREEN_EFF": "Green `123`",
                "EE_GREEN_RATING": "123",
                "EE_GREEN_SCORE": "123"
            }
        ],
        "EE_IMPACT_TO_VAL": "Beneficial",
        "EE_DESCRIPTION": "This is a test description",
        "PI_PROJ_NAME": "Project Name",
        "PI_MONTHLY_AMOUNT": "1500",
        "PU_MONTHLY_AMOUNT": "1501",
        "PU_ASSOCIATION_CHARGE_TYPE_AD": "Yes",
        "PI_AMENITIES_SERVICES_INCLUDED": "Yes",
        "PU_AMENITIES_SERVICES_INCLUDED": "Yes",
        "PI_UNIT_SPECIAL_ASSESSMENTS_DETAIL": "No",
        "PU_UNIT_SPECIAL_ASSESSMENTS_DETAIL": "No",
        "PU_UNIT_SPECIAL_ASSESSMENTS_AMNT": "2000",
        "HOME_WIDTH": "10 foot",
        "SaleListingInformation": [
            {
                "SLI_LIST_STATUS": "Sale",
                "SLI_LIST_CUR_OR_FINAL_LP": "Current List Price",
            },
            {
                "SLI_LIST_STATUS": "Sold",
                "SLI_LIST_CUR_OR_FINAL_LP": "Final List Price",
            },
            {
                "SLI_LIST_STATUS": "Sold",
                "SLI_LIST_CUR_OR_FINAL_LP": "Final List Price",
            }
        ],
        "Dwellings": [
            {
                "UNIT_NUMS": "6",
                "STRUCTURE_DESIGN_TYPE": "Ranch Home",
                "STYLE": "Ranch",
                "FRONT_DOOR_ELEV": "2-3 Ft.",
                "TOWNHOUSE_END_UNIT": "Yes",
                "TOWNHOUSE_BACK2BACK": "No",
                "UNITS_ABOVE_OR_BELOW": "No",
                "TOWNHOUSE_LOC": "Oklahoma City",
                "PJIYRBUILT": "2012",
                "PUIYRBUILT": "",
                "PUIYRBUILT_ESTIMATED": "No",
                "CONST_METHOD": "Manufactured",
                "CONVERTED_AREA": "Yes",
                "STRUCTURE_VOL": "4000",
                "WINDOW_SURFACE_AREA": "100",
                "GROSS_FINISHED_AREA_SF": "2,000",
                "EXT_QUAL_RATING": "Q1",
                "EXT_COND_RATING": "C1",
                "EXTEXTWALLS": "Stone",
                "EXT_FEAT_COND_STATUS": "Great",
                "Foundations": [
                    {
                        "EXT_FOUNDATION_DETAIL": "Sand | Natural",
                        "EXT_FOUNDATION_MATERIAL_DETAIL": "Sand",
                        "EXT_FOUNDATION_TYPE_DETAIL": "Natural",
                        "EXT_FOUNDATION_STATUS": ""
                    },
                    {
                        "EXT_FOUNDATION_DETAIL": "Brick | Natural",
                        "EXT_FOUNDATION_MATERIAL_DETAIL": "Brick",
                        "EXT_FOUNDATION_TYPE_DETAIL": "Natural",
                        "EXT_FOUNDATION_STATUS": ""
                    }
                ],
                "EXT_WINDOW_DETAIL_FLATTENED": "Double Pane Vinyl | New",
                "EXT_WINDOW_DETAIL": "Double Pane Vinyl",
                "EXT_WINDOW_STATUS": "New",
                "Roof": {
                    "EXTRFSURFACE": "Composition | Yes | 10-20 years",
                    "EXTRFSURFACE_OBSERVABLE": "Yes",
                    "EXTRFSURFACE_TYPE": "Composition",
                    "EXTRFSURFACE_AGE": "10-20 years"
                },
                "FinishedAreaRoomSummary": [
                    {
                        "FINISHED_AREA_TOTAL_AREA_FLATTENED": "2500 | 2 | Bedroom",
                        "FINISHED_AREA_TOTAL_AREA": "2500",
                        "FINISHED_AREA_ROOM_SUMMARY_TOTAL_ROOM": "2",
                        "FINISHED_AREA_ROOM_SUMMARY_ROOM_TYPE": "Bedroom"
                    },
                    {
                        "FINISHED_AREA_TOTAL_AREA_FLATTENED": "2600 | 2 | Dining Room",
                        "FINISHED_AREA_TOTAL_AREA": "2600",
                        "FINISHED_AREA_ROOM_SUMMARY_TOTAL_ROOM": "2",
                        "FINISHED_AREA_ROOM_SUMMARY_ROOM_TYPE": "Dining Room"
                    }
                ],
                "Heating": [
                    {
                        "HEAT_SYSTEM_FLATTENED": "Fireplace | Wood ",
                        "HEAT_SYSTEM": "Fireplace",
                        "HEAT_DETAIL": "Electric"
                    },
                    {
                        "HEAT_SYSTEM_FLATTENED": "Baseboard | Natural Gas ",
                        "HEAT_SYSTEM": "Baseboard",
                        "HEAT_DETAIL": "Natural Gas"
                    }
                ],
                "Cooling": [
                    {
                        "COOL_SYSTEM": "Centralized",
                    }
                ],
                "OTHER_MECH_SYSTEM": "Test Data",
                "Units": [
                    {
                        "FINISHED_ABOVE_GRADE": "1500",
                        "FINISHED_ABOVE_GRADE_NONSTD": "300",
                        "UNFINISHED_ABOVE_GRADE": "100",
                        "FINISHED_BELOW_GRADE": "2300",
                        "FINISHED_BELOW_GRADE_NONSTD": "400",
                        "AREA_DATA_SOURCE_TYPE": "Public Records",
                        "UNIT_LEVELS": "3",
                        "OCCUPANCY": "Owner",
                        "FLOOR_NUMBER": "2",
                        "CORNER_UNIT": "Yes",
                        "TOT_BEDS": "5",
                        "TOT_BATHS_FULL": "",
                        "TOT_BATHS_HALF": "",
                        "Levels": [
                            {
                                "LEVEL_IN_UNIT_FLATTENED": "Level 1 | Above Grade | 3006 | 0",
                                "LEVEL_IN_UNIT": "Level 1",
                                "LEVEL_GRADE_TYPE": "Above Grade",
                                "LEVEL_BELOW_GRADE_ACCESS": "",
                                "LEVEL_BELOW_GRADE_EXTERIOR_ACCESS": "",
                                "LEVEL_FINISHED_AREA": "3006",
                                "LEVEL_FINISHED_AREA_NONSTANDARD": "",
                                "LEVEL_UNFINISHED_AREA": "0"
                            },
                            {
                                "LEVEL_IN_UNIT_FLATTENED": "Level 2 | Above Grade | 1127 | 0",
                                "LEVEL_IN_UNIT": "Level 2",
                                "LEVEL_GRADE_TYPE": "Above Grade",
                                "LEVEL_BELOW_GRADE_ACCESS": "",
                                "LEVEL_BELOW_GRADE_EXTERIOR_ACCESS": "",
                                "LEVEL_FINISHED_AREA": "1127",
                                "LEVEL_FINISHED_AREA_NONSTANDARD": "",
                                "LEVEL_UNFINISHED_AREA": "0"
                            }
                        ],
                        "Rooms": [
                            {
                                "ROOM_LEVEL_FLATTENED": "Level B1 | Bedroom",
                                "ROOM_LEVEL": "Level B1",
                                "ROOM_ROOM_TYPE": "Bedroom"
                            },
                            {
                                "ROOM_LEVEL_FLATTENED": "Level B1 | Bedroom",
                                "ROOM_LEVEL": "Level B1",
                                "ROOM_ROOM_TYPE": "Bedroom"
                            },
                            {
                                "ROOM_LEVEL_FLATTENED": "Level B1 | Bedroom",
                                "ROOM_LEVEL": "Level B1",
                                "ROOM_ROOM_TYPE": "Bedroom"
                            },
                            {
                                "ROOM_LEVEL_FLATTENED": "Level 1 | Bedroom",
                                "ROOM_LEVEL": "Level 1",
                                "ROOM_ROOM_TYPE": "Bedroom"
                            },
                            {
                                "ROOM_LEVEL_FLATTENED": "Level 1 | Bedroom",
                                "ROOM_LEVEL": "Level 1",
                                "ROOM_ROOM_TYPE": "Bedroom"
                            },
                            {
                                "ROOM_LEVEL_FLATTENED": "Level 1 | Bath - Full",
                                "ROOM_LEVEL": "Level 1",
                                "ROOM_ROOM_TYPE": "Bath - Full"
                            },
                            {
                                "ROOM_LEVEL_FLATTENED": "Level 1 | Bath - Full",
                                "ROOM_LEVEL": "Level 1",
                                "ROOM_ROOM_TYPE": "Bath - Full"
                            }
                        ],
                        "Mechanical": [
                            {
                                "OTHER_MECH_SYSTEM": ""
                            }
                        ]
                    }
                ],
                "HEAT_BELOW_GRADE_FLATTENED": "X",
                "HEAT_BELOW_GRADE_YES": "X",
                "HEAT_BELOW_GRADE_NO": "",
                "Defects": [
                    {
                        "DEFECT_FEATURE_FLATTENED": "Foundation | test | test | Yes | Completion",
                        "DEFECT_FEATURE": "Foundation",
                        "DEFECT_LOCATION": "test",
                        "DEFECT_DESC": "test",
                        "DEFECT_INTEGRITY": "Yes",
                        "DEFECT_RECOMMEND_ACTION": "Completion"
                    },
                    {
                        "DEFECT_FEATURE_FLATTENED": "Mechanical System | test | test | Yes | Repair",
                        "DEFECT_FEATURE": "Mechanical System",
                        "DEFECT_LOCATION": "test",
                        "DEFECT_DESC": "test",
                        "DEFECT_INTEGRITY": "Yes",
                        "DEFECT_RECOMMEND_ACTION": "Repair"
                    }
                ]
            }
        ],
        "VehicleStorage": [
            {
                "VS_CAR_STORAGE": "Garage | Attached | 1170",
                "VS_PU_STORAGE_NUMBER_SPACES": "",
                "VS_PU_STORAGE_SPACE_SQUARE_FEET": "1170",
                "VS_PU_CAR_STORAGE_YES": "",
                "VS_PU_CAR_STORAGE_NO": "",
                "VS_PU_DRIVEWAY_SURFACE_MATERIAL": "",
                "VS_PU_PARKING_SPACE_ASSIGNMENT": "",
                "VS_PU_STORAGE_TYPE_DETAIL": "Attached",
                "VS_PU_CAR_STORAGE_TYPE": "Garage"
            },
            {
                "VS_CAR_STORAGE": "Driveway | 5 | Brick",
                "VS_PU_STORAGE_NUMBER_SPACES": "5",
                "VS_PU_STORAGE_SPACE_SQUARE_FEET": "",
                "VS_PU_CAR_STORAGE_YES": "",
                "VS_PU_CAR_STORAGE_NO": "",
                "VS_PU_DRIVEWAY_SURFACE_MATERIAL": "Brick",
                "VS_PU_PARKING_SPACE_ASSIGNMENT": "",
                "VS_PU_STORAGE_TYPE_DETAIL": "",
                "VS_PU_CAR_STORAGE_TYPE": "Driveway"
            }
        ],
        "Amenities": [
            {
                "AmenityCategory": [
                    {
                        "SPA_AMENITY_CATEGORY": "Patio | Concrete | 230",
                        "PU_SPA_AMENITY_CATEGORY": "Patio",
                        "PU_SPA_AMENITY_TYPE": "Patio",
                        "PU_SPA_AMENITY_MATERIAL": "Concrete",
                        "PU_SPA_AMENITY_TOTALNUM": "",
                        "PU_SPA_AMENITY_DETAIL_AREA": "230",
                        "PU_SPA_AMENITY_DETAIL_AREA_UNIT": "",
                        "PU_SPA_AMENITY_DETAIL_FEATURE": ""
                    },
                    {
                        "SPA_AMENITY_CATEGORY": "Indoor Fireplace | 1 Story | 1",
                        "PU_SPA_AMENITY_CATEGORY": "Indoor Fireplace",
                        "PU_SPA_AMENITY_TYPE": "Indoor Fireplace",
                        "PU_SPA_AMENITY_MATERIAL": "1 Story",
                        "PU_SPA_AMENITY_TOTALNUM": "1",
                        "PU_SPA_AMENITY_DETAIL_AREA": "",
                        "PU_SPA_AMENITY_DETAIL_AREA_UNIT": "",
                        "PU_SPA_AMENITY_DETAIL_FEATURE": ""
                    }
                ]
            }
        ],
        "FO_FUNCTIONAL_ISSUE_TYPE": "Over Improvement", 
        "Outbuildings": [
            {
                "OUTBUILDING_TYPE": "Barn",
                "CONSIDERED_REAL_PROP": "Yes",
                "TOTAL_AREA_FINISHED": "4000",
                "TOTAL_AREA_UNFINISHED": "1500",
                "HEATING_FLATTENED": "X",
                "HEATING_YES": "X",
                "HEATING_NO": "",
                "MechanicalHeatSystem": [
                    {
                        "MECH_HEAT_FLATTENED": "Fireplace | Wood ",
                        "MECH_HEAT_SYSTEM": "Fireplace",
                        "MECH_HEAT_DETAIL": "Wood"
                    },
                    {
                        "MECH_HEAT_FLATTENED": "Space Heater | Electric ",
                        "MECH_HEAT_SYSTEM": "Space Heater",
                        "MECH_HEAT_DETAIL": "Electric"
                    }
                ],
                "MECH_COOL_SYSTEM": "AC unit",
                "OTH_MECH_SYSTEMS": "",
                "COOLING_FLATTENED": "X",
                "COOLING_YES": "X",
                "COOLING_NO": ""
            },
            {
                "OUTBUILDING_TYPE": "Boathouse",
                "CONSIDERED_REAL_PROP": "No",
                "TOTAL_AREA_FINISHED": "1500",
                "TOTAL_AREA_UNFINISHED": "250",
                "HEATING_FLATTENED": "",
                "HEATING_YES": "",
                "HEATING_NO": "X",
                "MechanicalHeatSystem": [
                    {
                        "MECH_HEAT_FLATTENED": "Fireplace | Wood ",
                        "MECH_HEAT_SYSTEM": "Fireplace",
                        "MECH_HEAT_DETAIL": "Wood"
                    },
                ],
                "MECH_COOL_SYSTEM": "",
                "OTH_MECH_SYSTEMS": "",
                "COOLING_FLATTENED": "",
                "COOLING_YES": "",
                "COOLING_NO": "X"
            },
            {
                "OUTBUILDING_TYPE": "Greenhouse",
                "CONSIDERED_REAL_PROP": "No",
                "TOTAL_AREA_FINISHED": "2000",
                "TOTAL_AREA_UNFINISHED": "150",
                "HEATING_FLATTENED": "X",
                "HEATING_YES": "X",
                "HEATING_NO": "",
                "MechanicalHeatSystem": [
                    {
                        "MECH_HEAT_FLATTENED": "Fireplace | Wood ",
                        "MECH_HEAT_SYSTEM": "Fireplace",
                        "MECH_HEAT_DETAIL": "Wood"
                    },
                    {
                        "MECH_HEAT_FLATTENED": "Space Heater | Electric ",
                        "MECH_HEAT_SYSTEM": "Space Heater",
                        "MECH_HEAT_DETAIL": "Electric"
                    }
                ],
                "MECH_COOL_SYSTEM": "",
                "OTH_MECH_SYSTEMS": "",
                "COOLING_FLATTENED": "X",
                "COOLING_YES": "X",
                "COOLING_NO": ""
            }
        ],
        "SC_CONTRACT_SALES_PRICE": "350,000",
        "SC_CONTRACT_DATE": "2026-04-15",
        "SC_TRANSFER_TERMS": "None",
        "SC_KWN_CONCESSIONS": "Yes",
        "SC_TOTAL_CONCESSIONS": "2000"
    }

    return data;
}

function PRCompPayload(): any {
    const data = {
        "AD_ADDR1": "539 Shirley LN NE",
        "DB_UNITNO": "Apt 4B",
        "DB_CITY": "Piedmont",
        "DB_STATE": "OK",
        "DB_ZIP": "73078",
        "SC_SOURCE1": "MLS",
        "PU_DATA_SOURCE": "MLS",
        "PU_DATA_SOURCE_ASSESSOR_ID": "MLS",
        "PU_DATA_SOURCE_MLS_NUM": "1",
        "PROX1": "0.5 miles NW",
        "PU_DISTANCE": "0.5",
        "PU_MILES": "0.5",
        "PU_KILOMETERS": "0.5",
        "PU_DIRECTION": "Standard Direction",
        "LP_PRICE": "350000",
        "LP_STATUS": "Closed",
        "CONT_PRICE": "350000",
        "PU_CONT_PRICE_KNOWN": "350000",
        "PU_CONT_PRICE": "350000",
        "PR_SALEPR1": "350000",
        "TRANSFER_TERMS": "1850",
        "DP_FINTYP1": "Conventional",
        "EX_CONCAMT": "350000",
        "PU_CONC_PRESENT": "Standard Concessions Present",
        "PU_CONC_AMOUNT": "Standard Concession Amount",
        "CONT_DATE": "2026-04-15",
        "PU_CONT_DATE_KNOWN": "2026-04-15",
        "PU_CONT_DATE": "2026-04-15",
        "DT_SALTIM1": "2026-04-15",
        "EX_DOM": "35",
        "SP_TO_LP_RATIO": "350000",
        "ATT_DET": "Standard Attached/Detached",
        "PROP_APPRAISER_RIGHTS": "Standard Property Rights Appraised",
        "ANNUAL_GRND_RENT": "Standard Annual Ground Rent",
        "NATIVE_AM_LANDS": "Standard Native American Lands",
        "PU_NATIVE_AM_LANDS_YES": "1",
        "PU_NATIVE_AM_LANDS_NO": "0",
        "PU_NATIVE_AM_LANDS_TYPE": "Standard Native American Lands Type",
        "ALL_RIGHTS_INCLUDED": "Standard All Rights Included",
        "RIGHTS_NOT_INCLUDED": "Standard Rights Not Included",
        "SAME_BLDR_AS_SUBJECT": "Standard Same Builder as Subject",
        "GI_BLANK": "",
        "PROJ_NAME": "Standard Project Name ",
        "PU_PROJECT_NAME": "Standard Project Name",
        "PU_SAME_PROJECT_AS_SUBJECT": "Standard Same Project",
        "PROJ_MONTHLY_FEE": "Standard Monthly Fee",
        "PROJ_AMENITIES": "None",
        "PROJ_SPECIAL_ASSESSMENTS": "Standard Special Assessments",
        "SITE_PROJECT_TYPE": "Standard Project Type",
        "SITE_OWNED_IN_COMMON": "Standard Site Owned In Common",
        "ST_SITSIZE": "0.25",
        "MARKETAREA": "Oakridge Estates",
        "SITE_ZONE_COMPLIANCE": "Standard Zoning Compliance",
        "SITE_HAZARD_ZONE": "Standard Hazard Zone",
        "SITE_PRIMARY_ACCESS": "Standard Primary Access",
        "SiteStreetType": [
            {
                "SITE_STREET_TYPE": "Cul-de-sac | Paved",
                "PU_SITE_STREET_TYPE": "Cul-de-sac",
                "PU_SITE_STREET_SURFACE": "Paved"
            },
            {
                "SITE_STREET_TYPE": "Dead End | Paved",
                "PU_SITE_STREET_TYPE": "Dead End",
                "PU_SITE_STREET_SURFACE": "Paved"
            }
        ],
        "SITE_PROP_RESTRICT": "Standard Property Restriction",
        "SITE_EASEMENT": "Standard Easement",
        "SITE_TOPOGRAPHY": "Standard Topography",
        "SiteDrainage": [
            {
                "SITE_DRAINAGE": "Standard Drainage"
            }
        ],
        "SITE_CHARACTERISTICS": "Standard Site Characteristics",
        "SITE_INFLUENCE": "Standard Site Influence",
        "PU_SITE_INFLUENCE": "Standard Site Influence",
        "PU_SITE_INFLUENCE_PRIVATE_ACCESS": "Standard Site Influence Private Access",
        "PU_SITE_INFLUENCE_WATER_TYPE": "Standard Site Influence Water Type",
        "SITE_ENV_COND": "C3",
        "SiteViews": [
            {
                "ST_VIEW": "Creek | Seasonal",
                "PU_ST_VIEW": "Creek",
                "PU_ST_RANGE": "Seasonal"
            },
            {
                "ST_VIEW": "Marsh | Partial",
                "PU_ST_VIEW": "Marsh",
                "PU_ST_RANGE": "Partial"
            }
        ],
        "SITE_BLANK": "",
        "Dwellings": [
            {
                "YR_BLT": "1970 | No",
                "PU_YR_BLT": "1970",
                "PU_YR_BLT_EST": "No",
                "DWELL_DESIGN": "Colonial",
                "PU_STRUCTURE_DESIGN": "Colonial",
                "SF_GLA": "1850",
                "SF_FINISHED_AREA": "1850",
                "DWELL_TH_ENDUNIT": "Apt 4B",
                "PU_DWELL_TH_ENDUNIT": "Apt 4B",
                "DWELL_TH_BACKTOBACK": "Standard Townhouse Back to Back",
                "PU_DWELL_TH_BACKTOBACK": "Standard Townhouse Back to Back",
                "DWELL_TH_LOC": "Standard Townhouse Location",
                "PU_DWELL_TH_LOC": "Standard Townhouse Location",
                "DWELL_CONST_METHOD": "Stick Built",
                "PU_DWELL_CONST_METHOD": "Stick Built",
                "DWELL_MANFCT_HOME_WIDTH": "12-34-567-890",
                "PU_DWELL_MANFCT_HOME_WIDTH": "12-34-567-890",
                "DWELL_STYLE": "Colonial",
                "PU_DWELL_STYLE": "Colonial",
                "DWELL_TOTAL_VOLUME": "1850",
                "DWELL_WINDOW_AREA": "1850",
                "DWELL_FUNC_ISSUES": "Standard Functional Issues",
                "PU_DWELL_FUNC_ISSUES": "Standard Functional Issues",
                "DWELL_DISASTER_MIT": "Standard Disaster Mitigation",
                "PU_DWELL_DISASTER_MIT": "Standard Disaster Mitigation",
                "Heating": [
                    {
                        "DWELL_HEAT": "Passive Solar | Geothermal ",
                        "PU_DWELL_HEAT_SYSTEM": "Passive Solar",
                        "PU_DWELL_HEAT_DETAIL": "Geothermal"
                    },
                    {
                        "DWELL_HEAT": "Forced Warm Air | Electric ",
                        "PU_DWELL_HEAT_SYSTEM": "Forced Warm Air",
                        "PU_DWELL_HEAT_DETAIL": "Electric"
                    },
                ],
                "Cooling": [
                    {
                        "DWELL_COOL": "Centralized ",
                        "PU_DWELL_COOL": "Centralized ",
                    },
                    {
                        "DWELL_COOL": "Centralized ",
                        "PU_DWELL_COOL": "Centralized ",
                    }
                ],
                "DWELL_OTHR1_BLANK": "",
                "Units": [
                    {
                        "UNIT_ID": "Apt 4B",
                        "UNITS_IS_AN_ADU": "Apt 4B",
                        "LOC_ADU": "Standard Location of ADU",
                        "PU_LOC_ADU_TYPE": "Standard Location Type",
                        "PU_LOC_ADU_DESC": "Standard Location Description",
                        "FLOOR_NUM": "1",
                        "CORNER_UNIT": "Apt 4B",
                        "LEVELS": "Apt 4B",
                        "BEDS": "3",
                        "BATHS": "2.5",
                        "PU_FULL_BATHS": "2.5",
                        "PU_HALF_BATHS": "2.5",
                        "UNITS_SF_GLA": "1850",
                        "UNITS_SF_GLA_NONSTD": "1850",
                        "UNITS_SF_GLA_UNFIN": "1850",
                        "UNITS_SF_GLA_BELOW_GRD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_NONSTD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_UNFIN": "1850",
                        "DISABILITY_FEATURES": "Standard Features for Individuals w/Disabilities",
                        "UNITS_BLANK": ""
                    },
                    {
                        "UNIT_ID": "Apt 4C",
                        "UNITS_IS_AN_ADU": "Apt 4C",
                        "LOC_ADU": "Standard Location of ADU",
                        "PU_LOC_ADU_TYPE": "Standard Location Type",
                        "PU_LOC_ADU_DESC": "Standard Location Description",
                        "FLOOR_NUM": "1",
                        "CORNER_UNIT": "Apt 4C",
                        "LEVELS": "Apt 4C",
                        "BEDS": "3",
                        "BATHS": "2.5",
                        "PU_FULL_BATHS": "2.5",
                        "PU_HALF_BATHS": "2.5",
                        "UNITS_SF_GLA": "1850",
                        "UNITS_SF_GLA_NONSTD": "1850",
                        "UNITS_SF_GLA_UNFIN": "1850",
                        "UNITS_SF_GLA_BELOW_GRD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_NONSTD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_UNFIN": "1850",
                        "DISABILITY_FEATURES": "Standard Features for Individuals w/Disabilities",
                        "UNITS_BLANK": ""
                    }
                ]
            },
            {
                "YR_BLT": "1971 | No",
                "PU_YR_BLT": "1971",
                "PU_YR_BLT_EST": "No",
                "DWELL_DESIGN": "Colonial",
                "PU_STRUCTURE_DESIGN": "Colonial",
                "SF_GLA": "2050",
                "SF_FINISHED_AREA": "2050",
                "DWELL_TH_ENDUNIT": "Apt 8B",
                "PU_DWELL_TH_ENDUNIT": "Apt 8B",
                "DWELL_TH_BACKTOBACK": "Standard Townhouse Back to Back",
                "PU_DWELL_TH_BACKTOBACK": "Standard Townhouse Back to Back",
                "DWELL_TH_LOC": "Standard Townhouse Location",
                "PU_DWELL_TH_LOC": "Standard Townhouse Location",
                "DWELL_CONST_METHOD": "Stick Built",
                "PU_DWELL_CONST_METHOD": "Stick Built",
                "DWELL_MANFCT_HOME_WIDTH": "10 feet",
                "PU_DWELL_MANFCT_HOME_WIDTH": "10 feet",
                "DWELL_STYLE": "Colonial",
                "PU_DWELL_STYLE": "Colonial",
                "DWELL_TOTAL_VOLUME": "3000",
                "DWELL_WINDOW_AREA": "3000",
                "DWELL_FUNC_ISSUES": "Standard Functional Issues",
                "PU_DWELL_FUNC_ISSUES": "Standard Functional Issues",
                "DWELL_DISASTER_MIT": "Standard Disaster Mitigation",
                "PU_DWELL_DISASTER_MIT": "Standard Disaster Mitigation",
                "Heating": [
                    {
                        "DWELL_HEAT": "Fireplace | Wood ",
                        "PU_DWELL_HEAT_SYSTEM": "Fireplace",
                        "PU_DWELL_HEAT_DETAIL": "Wood"
                    },
                    {
                        "DWELL_HEAT": "Baseboard | Natural Gas ",
                        "PU_DWELL_HEAT_SYSTEM": "Baseboard",
                        "PU_DWELL_HEAT_DETAIL": "Natural Gas"
                    },
                    {
                        "DWELL_HEAT": "Radiator | Electric ",
                        "PU_DWELL_HEAT_SYSTEM": "Radiator",
                        "PU_DWELL_HEAT_DETAIL": "Electric"
                    }
                ],
                "Cooling": [
                    {
                        "DWELL_COOL": "Centralized ",
                        "PU_DWELL_COOL": "Centralized ",
                    }
                ],
                "DWELL_OTHR1_BLANK": "",
                "Units": [
                    {
                        "UNIT_ID": "Apt 8B",
                        "UNITS_IS_AN_ADU": "Apt 8B",
                        "LOC_ADU": "Standard Location of ADU",
                        "PU_LOC_ADU_TYPE": "Standard Location Type",
                        "PU_LOC_ADU_DESC": "Standard Location Description",
                        "FLOOR_NUM": "1",
                        "CORNER_UNIT": "Apt 8B",
                        "LEVELS": "Apt 8B",
                        "BEDS": "5",
                        "BATHS": "4",
                        "PU_FULL_BATHS": "4",
                        "PU_HALF_BATHS": "0",
                        "UNITS_SF_GLA": "1850",
                        "UNITS_SF_GLA_NONSTD": "1850",
                        "UNITS_SF_GLA_UNFIN": "1850",
                        "UNITS_SF_GLA_BELOW_GRD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_NONSTD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_UNFIN": "1850",
                        "DISABILITY_FEATURES": "Standard Features for Individuals w/Disabilities",
                        "UNITS_BLANK": ""
                    },
                    {
                        "UNIT_ID": "Apt 9C",
                        "UNITS_IS_AN_ADU": "Apt 9C",
                        "LOC_ADU": "Standard Location of ADU",
                        "PU_LOC_ADU_TYPE": "Standard Location Type",
                        "PU_LOC_ADU_DESC": "Standard Location Description",
                        "FLOOR_NUM": "1",
                        "CORNER_UNIT": "Apt 9C",
                        "LEVELS": "Apt 9C",
                        "BEDS": "3",
                        "BATHS": "6",
                        "PU_FULL_BATHS": "6",
                        "PU_HALF_BATHS": "6",
                        "UNITS_SF_GLA": "1850",
                        "UNITS_SF_GLA_NONSTD": "1850",
                        "UNITS_SF_GLA_UNFIN": "1850",
                        "UNITS_SF_GLA_BELOW_GRD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_NONSTD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_UNFIN": "1850",
                        "DISABILITY_FEATURES": "Standard Features for Individuals w/Disabilities",
                        "UNITS_BLANK": ""
                    }
                ]
            }
        ],
        "WaterFrontages": [
            {
                "WATER_FRONTAGE": "Canal | Martha's Canal | Deep Water",
                "PU_WATER_FRONTAGE_TYPE": "Canal",
                "PU_WATER_FRONTAGE_NAME": "Martha's Canal",
                "PU_WATER_FRONTAGE_ACCESS_DEPTH": "Deep Water"
            },
            {
                "WATER_FRONTAGE": "Lake | Crystal Lake | Deep Water",
                "PU_WATER_FRONTAGE_TYPE": "Lake",
                "PU_WATER_FRONTAGE_NAME": "Crystal Lake",
                "PU_WATER_FRONTAGE_ACCESS_DEPTH": "Deep Water"
            }
        ],
        "WATER_FRONTAGE_FEAT": "Standard Permanent Waterfront Feature",
        "WATER_RIGHT_BLD": "Standard Right to Build",
        "WATER_LINEAR_MEASURE": "Standard Total Linear Measurement",
        "PU_WATER_LINEAR_MEASURE": "Standard Water Linear Measure",
        "PU_WATER_LINEAR_MEASURE_FEET": "",
        "PU_WATER_LINEAR_MEASURE_METERS": "",
        "GREEN_RENEW_ENERGY_ONENT": "Standard Renewable Energy Component",
        "BuildingCertifications": [
            {
                "GREEN_BUILD_CERT": "Certification | 13%",
                "PU_GREEN_BUILD_CERT_DESC": "Certification",
                "PU_GREEN_BUILD_CERT_RATE": "13%"
            },
            {
                "GREEN_BUILD_CERT": "Certification 2 | 30%",
                "PU_GREEN_BUILD_CERT_DESC": "Certification 2",
                "PU_GREEN_BUILD_CERT_RATE": "30%"
            }
        ],
        "EfficiencyRatings": [
            {
                "GREEN_EFF_RATING": "B- | 81",
                "PU_GREEN_EFF_RATING": "B-",
                "PU_GREEN_EFF_SCORE": "81"
            },
            {
                "GREEN_EFF_RATING": "A- | 98",
                "PU_GREEN_EFF_RATING": "A-",
                "PU_GREEN_EFF_SCORE": "98"
            }
        ],
        "ExteriorQualities" : [
            {
                "EXT_QUAL_STRUCTURE_ID": "Q3",
                "EXT_QUAL_QUALITY": "Q3",
                "EXT_QUAL_EXT_WALLS_TRIM": "Standard / Typical",
                "EXT_QUAL_FOUNDATION": "Standard / Typical",
                "EXT_QUAL_ROOF": "Standard / Typical",
                "EXT_QUAL_WINDOWS": "Q3",
                "BLExteriorQualities" : [
                    {
                        "EXT_QUAL_BLANK_LABEL": "",
                        "EXT_QUAL_BLANK": "",
                    }
                ],
            },
        ],
        "ExteriorConditions" : [
            {
                "EXT_COND_CONDITION": "B3",
                "EXT_COND_WALLS_TRIM": "Standard / Typical",
                "EXT_COND_FOUNDATION": "Standard / Typical",
                "EXT_COND_ROOF": "Standard / Typical",
                "PU_EXT_COND_ROOF_OBSERVABLE": "Standard / Typical",
                "PU_EXT_COND_ROOF_STATUS": "Standard / Typical",
                "EXT_COND_WINDOWS": "B3",
                "BLExteriorConditions" : [
                    {
                        "EXT_COND_BLANK_LABEL": "",
                        "EXT_COND_BLANK": "",
                    }
                ],
            },
        ],
        "InteriorQualities" : [
            {
                "INT_QUAL_STRUCTURE_ID": "Apt 4B",
                "INT_QUAL_QUALITY": "Q3",
                "INT_QUAL_KITCHEN": "Q3",
                "INT_QUAL_BATHS": "2.5",
                "INT_QUAL_FLOORS": "Q3",
                "INT_QUAL_WALLS_CEILINGS": "Standard / Typical",
                "INT_QUAL_BLANK": "",
                "BLInteriorQuality" : [
                    {
                        "INT_QUAL_BLANK_LABEL": "",
                        "INT_QUAL_BLANK": "",
                    }
                ],
            }
        ],
        "InteriorConditions" : [
            {
                "INT_COND_CONDITION": "C3",
                "INT_COND_KITCHEN": "C3",
                "INT_COND_BATHS": "2.5",
                "INT_COND_FLOORS": "C3",
                "INT_COND_WALLS_CEILINGS": "Standard / Typical",
                "BLInteriorConditions" : [
                    {
                        "INT_COND_BLANK_LABEL": "",
                        "INT_COND_BLANK": "",
                    }
                ],
            }
        ],
        "ADUQualities" : [
            {
                "ADU_LOCATION": "Standard ADU Location 1",
                "ADU_QUAL_QUALITY": "Q3",
                "ADU_QUAL_KITCHEN": "Q3",
                "INT_ADU_COND_BATHS": "2.5",
                "ADU_QUAL_FLOORS": "Q3",
                "ADU_QUAL_WALLS_CEILINGS": "Standard / Typical",
                "ADU_QUAL_BLANK": "",
                "BLADUQualities" : [
                    {
                        "ADU_QUAL_BLANK_LABEL": "",
                        "ADU_QUAL_BLANK": "",
                    }
                ]
            }
        ],
        "ADUConditions" : [
            {
                "ADU_COND_CONDITION": "C3",
                "ADU_COND_KITCHEN": "C3",
                "ADU_COND_BATHS": "2.5",
                "ADU_COND_FLOORS": "C3",
                "ADU_COND_WALLS_CEILINGS": "Standard / Typical",
                "ADU_COND_BLANK": "",
                "BLADUConditions" : [
                    {
                        "ADU_COND_BLANK_LABEL": "",
                        "ADU_COND_BLANK": "",
                    }
                ],
            }
        ],
        "QUALITY": "Q3",
        "CONDITION": "C3",
        "Amenities": [
            {
                "OutdoorAccessories": [
                    {
                        "AMENITY_OUTDOOR_ACCESSORIES": "Outdoor Fireplace | 1",
                        "PU_AMENITY_OUTDOOR_ACCESSORIES": "Outdoor Fireplace",
                        "PU_AMENITY_OUTDOOR_ACCESSORIES_NUM": "1"
                    },
                    {
                        "AMENITY_OUTDOOR_ACCESSORIES": "Outdoor Kitchen | 1",
                        "PU_AMENITY_OUTDOOR_ACCESSORIES": "Outdoor Kitchen",
                        "PU_AMENITY_OUTDOOR_ACCESSORIES_NUM": "1"
                    }
                ],
                "OutdoorLiving": [
                    {
                        "AMENITY_OUTDOOR_LIVING": "Patio",
                        "PU_AMENITY_OUTDOOR_LIVING": "Patio"
                    },
                    {
                        "AMENITY_OUTDOOR_LIVING": "Porch",
                        "PU_AMENITY_OUTDOOR_LIVING": "Porch"
                    }
                ],
                "WaterFeatures": [
                    {
                        "AMENITY_WATER_FEATURES": "Outdoor Shower | 1 | 1",
                        "PU_AMENITY_WATER_FEATURE": "Outdoor Shower",
                        "PU_AMENITY_WATER_FEATURE_DETAIL": "1",
                        "PU_AMENITY_WATER_FEATURE_NUM": "1"
                    },
                    {
                        "AMENITY_WATER_FEATURES": "Sauna | Indoor | 1",
                        "PU_AMENITY_WATER_FEATURE": "Sauna",
                        "PU_AMENITY_WATER_FEATURE_DETAIL": "Indoor",
                        "PU_AMENITY_WATER_FEATURE_NUM": "1"
                    }
                ],
                "WholeHome": [
                    {
                        "AMENITY_WHOLE_HOME": "Elevator | 1",
                        "PU_AMENITY_WHOLE_HOME": "Elevator",
                        "PU_AMENITY_WHOLE_HOME_NUM": "1"
                    },
                    {
                        "AMENITY_WHOLE_HOME": "EV Station | 1",
                        "PU_AMENITY_WHOLE_HOME": "EV Station",
                        "PU_AMENITY_WHOLE_HOME_NUM": "1"
                    }
                ],
                "Miscellaneous": [
                    {
                        "AMENITY_MISC": "Indoor Fireplace | 1",
                        "PU_AMENITY_MISC": "Indoor Fireplace",
                        "PU_AMENITY_MISC_NUM": "1"
                    }
                ]
            }
        ],
        "VehicleStorage": [
            {
                "VEHICLE_STORAGE": "Garage | 3 | Attached | 1170",
                "PU_VEHICLE_STORAGE": "Garage",
                "PU_VEHICLE_STORAGE_SPACES": "3",
                "PU_VEHICLE_STORAGE_DETAILS": "Attached",
                "PU_VEHICLE_STORAGE_SQFT": "1170",
                "BL_VEHICLE_STORAGE": ""
            },
            {
                "VEHICLE_STORAGE": "Carport | 2 | Attached | 1170",
                "PU_VEHICLE_STORAGE": "Carport",
                "PU_VEHICLE_STORAGE_SPACES": "2",
                "PU_VEHICLE_STORAGE_DETAILS": "Attached",
                "PU_VEHICLE_STORAGE_SQFT": "300",
                "BL_VEHICLE_STORAGE": ""
            }
        ],
        "Outbuildings": [
            {
                "OUTBUILDING_TYPE": "Manufactured Home",
                "OUTBUILDING_REAL_PROPERTY": "Yes",
                "OUTBUILDING_BUILDING_AREA": "2000",
                "OUTBUILDING_FINISHED_AREA": "2000",
                "OUTBUILDING_UNFINISHED_AREA": "0",
                "OUTBUILDING_STRUCTURE_VOLUME": "2000",
                "OUTBUILDING_BATHS_FULL": "1",
                "OUTBUILDING_BATHS_HALF": "2",
                "OUTBUILDING_KITCHENS": "1",
                "OUTBUILDING_HEATING": "Yes",
                "OUTBUILDING_COOLING": "Yes",
                "OutbuildingUtilities": [
                    {
                        "OUTBUILDING_UTILITIES": "Electricity"
                    }
                ],
                "BLOutbuilding": [ // CURRENTLY NOT USED 
                    {
                        "BL_OUTBUILDING_BLANK": "",
                        "BL_OUTBUILDING": ""
                    }
                ]
            },
            {
                "OUTBUILDING_TYPE": "Stable",
                "OUTBUILDING_REAL_PROPERTY": "No",
                "OUTBUILDING_BUILDING_AREA": "3000",
                "OUTBUILDING_FINISHED_AREA": "2000",
                "OUTBUILDING_UNFINISHED_AREA": "1000",
                "OUTBUILDING_STRUCTURE_VOLUME": "1500",
                "OUTBUILDING_BATHS_FULL": "0",
                "OUTBUILDING_BATHS_HALF": "0",
                "OUTBUILDING_KITCHENS": "0",
                "OUTBUILDING_HEATING": "No",
                "OUTBUILDING_COOLING": "No",
                "OutbuildingUtilities": [
                    {
                        "OUTBUILDING_UTILITIES": "Electricity"
                    },
                    {
                        "OUTBUILDING_UTILITIES": "Water"
                    }
                ],
                "BLOutbuilding": [ // CURRENTLY NOT USED 
                    {
                        "BL_OUTBUILDING_BLANK": "",
                        "BL_OUTBUILDING": ""
                    }
                ]
            }
        ],
        "TransferHistories": [
            {
                "TRANSFER_HISTORY_PRESENT": "1950",
                "TRANSFER_HISTORY_TERMS": "1950",
                "TRANSFER_HISTORY_DATE": "2026-04-15",
                "TRANSFER_HISTORY_AMOUNT": "50000",
                "DFE_TRANSFER_HISTORY_AMOUNT_VALUE": "50000",
                "DFE_TRANSFER_HISTORY_AMOUNT_REASON": "1950",
                "TRANSFER_HISTORY_SOURCE": "1950",
            },
            {
                "TRANSFER_HISTORY_PRESENT": "2000",
                "TRANSFER_HISTORY_TERMS": "2000",
                "TRANSFER_HISTORY_DATE": "2026-04-15",
                "TRANSFER_HISTORY_AMOUNT": "150000",
                "DFE_TRANSFER_HISTORY_AMOUNT_VALUE": "150000",
                "DFE_TRANSFER_HISTORY_AMOUNT_REASON": "2000",
                "TRANSFER_HISTORY_SOURCE": "2000",
            },
            {
                "TRANSFER_HISTORY_PRESENT": "2000",
                "TRANSFER_HISTORY_TERMS": "2000",
                "TRANSFER_HISTORY_DATE": "2026-04-15",
                "TRANSFER_HISTORY_AMOUNT": "150000",
                "DFE_TRANSFER_HISTORY_AMOUNT_VALUE": "150000",
                "DFE_TRANSFER_HISTORY_AMOUNT_REASON": "2000",
                "TRANSFER_HISTORY_SOURCE": "2000",
            }
        ]
    }

    return data;
}

function SEBestSubjectPayload(): any {
        const data = {
            "records": 2,
            "yourCount": 0,
            "peerCount": 2,
            "reportUseCount": 1,
            "isPeerComp": true,
            "sourceData": {
                "SUB_PHOTO": "",
                "SUBPROPADDRESS": "539 Shirley LN NE",
                "SUBUNITNO": "",
                "SUBCITY": "Piedmont",
                "SUBSTATE": "OK",
                "SUBZIP": "73078",
                "SUBCOUNTY": "Oklahoma",
                "SUBPROJNAME": "RES-WAWONA DRIVE",
                "ATTACHMENT_TYPE": "Detached",
                "ProjectType": {
                    "PROJECT_TYPE_FLATTENED": "",
                    "PUD_YES": "",
                    "PUD_NO": "X",
                    "CONDO_YES": "",
                    "CONDO_NO": "X",
                    "COOP_YES": "",
                    "COOP_NO": "X",
                    "CONDOP_YES": "",
                    "CONDOP_NO": ""
                },
                "NativeAmericanLands": {
                    "NATAMLAND_FLATTENED": "",
                    "NATAMLAND_YES": "",
                    "NATAMLAND_NO": ""
                },
                "SiteOwnedInCommon": {
                    "SITE_OWNED_IN_COMMON_FLATTENED": "",
                    "SITOWNEDCOMMON_YES": "",
                    "SITOWNEDCOMMON_NO": ""
                },
                "HomeownerResponsible": {
                    "HORESPMAINT_FLATTENED": "X",
                    "HORESPMAINT_YES": "X",
                    "HORESPMAINT_NO": ""
                },
                "NewConstruction": {
                    "NEWCONST_FLATTENED": "",
                    "NEWCONST_YES": "",
                    "NEWCONST_NO": "X"
                },
                "PROPRIGHTSAPPR": "",
                "GROUND_RENTAL_ANNUAL_AMOUNT": "",
                "ALL_RIGHTS_INCLUDED": "",
                "RIGHTS_NOT_INCLUDED": "",
                "SUBLEGALDESCRIP": "PT LL 48 10/4",
                "Owners": [
                    {
                        "SUBCUROWNER": "JOHN CROWE",
                        "SUBCUROWNER_TYPE": "Individual",
                        "SUBCUROWNER_FIRST_NAME": "JOHN",
                        "SUBCUROWNER_MIDDLE_NAME": "",
                        "SUBCUROWNER_LAST_NAME": "CROWE",
                        "SUBCUROWNER_SUFFIX_NAME": "",
                        "SUBCUROWNER_FULL_NAME": "JOHN CROWE",
                    },
                    {
                        "SUBCUROWNER": "BRENDA CROWE",
                        "SUBCUROWNER_TYPE": "LegalEntity",
                        "SUBCUROWNER_FIRST_NAME": "",
                        "SUBCUROWNER_MIDDLE_NAME": "",
                        "SUBCUROWNER_LAST_NAME": "",
                        "SUBCUROWNER_SUFFIX_NAME": "",
                        "SUBCUROWNER_FULL_NAME": "BRENDA CROWE",
                    }
                ],
                "LATITUDE": "34.962639",
                "LONGITUDE": "-85.423553",
                "SITSITEAREA": "147233",
                "NUMPARCELS": "1",
                "PU_APN": "0520002000",
                "PU_ALT_APN": "052-00-020-00",
                "PU_APN_DESC": "",
                "PU_SOURCE_APN": "Data Aggregator",
                "PARCEL_SIZE": "147233",
                "SIT_COMPLIANCE": "",
                "SIT_PRIMACCESS": "Public Street",
                "SiteStreetType": [
                    {
                        "SIT_STREET_TYPE_SURFACE": "Cul-de-sac | Paved",
                        "PU_STREET_TYPE": "Cul-de-sac",
                        "PU_SURFACE_TYPE": "Paved"
                    },
                    {
                        "SIT_STREET_TYPE_SURFACE": "Dead End | Paved",
                        "PU_STREET_TYPE": "Dead End",
                        "PU_SURFACE_TYPE": "Paved"
                    }
                ],
                "SiteInfluence": [
                    {
                        "SIT_INFL_FLATTENED": "",
                        "SIT_INFL_INFL": "",
                        "PU_SITE_INFL_WTR_DTL_TYPE": "",
                        "PU_SITE_INFL_WTR_DTL_PRIV_ACCESS": ""
                    }
                ],
                "ViewImpairment": [
                    {
                        "SIT_VWIMP_VIEW_FLATTENED": "",
                        "SIT_VWIMP_VIEW": "",
                        "SIT_VWIMP_RNGVW": "",
                        "SIT_VWIMP_IMP": ""
                    }
                ],
                "SiteFeatures": [
                    {
                        "SIT_FEAT_HZRD_ZONE_DTL": "",
                        "SIT_FEAT_RSTRCTN_DTL": "",
                        "PU_SITE_FEAT_SITCHAR": "",
                        "PU_SITE_FEAT_SITCHAR_TOP_TYPE": "",
                        "PU_SITE_FEAT_SITCHAR_DRAIN_RSN": "",
                        "SIT_FEAT_EASEMENT_DTL": ""
                    }
                ],
                "DM_MITIGATION_FEATURE": "",
                "RenewableEnergyComponents": [
                    {
                        "EE_RENEWABLES": "",
                        "PU_EE_RENEWABLE_TYPE": "",
                        "PU_EE_OWNER_TYPE": "",
                        "PU_EE_FINANCING_ARRANGEMENT_YES": "",
                        "PU_EE_FINANCING_ARRANGEMENT_NO": ""
                    }
                ],
                "BuildingCertifications": [
                    {
                        "EE_CERTS_ORGANIZATION_FLATTENED": "",
                        "EE_CERTS_ORGANIZATION": "",
                        "EE_CERTS": "",
                        "EE_YEAR": "",
                        "EE_VERSION": "",
                        "EE_RATING": ""
                    }
                ],
                "EfficiencyRatings": [
                    {
                        "EE_GREEN_EFF_FLATTENED": "",
                        "EE_GREEN_EFF": "",
                        "EE_GREEN_RATING": "",
                        "EE_GREEN_SCORE": ""
                    }
                ],
                "EE_IMPACT_TO_VAL": "",
                "EE_DESCRIPTION": "",
                "PI_PROJ_NAME": "",
                "PI_MONTHLY_AMOUNT": "",
                "PU_MONTHLY_AMOUNT": "",
                "PU_ASSOCIATION_CHARGE_TYPE_AD": "",
                "PI_AMENITIES_SERVICES_INCLUDED": "",
                "PU_AMENITIES_SERVICES_INCLUDED": "",
                "UNIT_SPECIAL_ASSESSMENTS_FLATTENED": "",
                "PU_UNIT_SPECIAL_ASSESSMENTS_DETAIL": "",
                "PU_UNIT_SPECIAL_ASSESSMENTS_AMNT": "",
                "HOME_WIDTH": "",
                "SaleListingInformation": [
                    {
                        "SLI_LIST_STATUS": "",
                        "SLI_LIST_CUR_OR_FINAL_LP": ""
                    }
                ],
                "Dwellings": [
                    {
                        "UNIT_NUMS": "",
                        "STRUCTURE_DESIGN_TYPE": "",
                        "STYLE": "",
                        "FRONT_DOOR_ELEV": "",
                        "TOWNHOUSE_END_UNIT": "",
                        "TOWNHOUSE_BACK2BACK": "",
                        "UNITS_ABOVE_OR_BELOW": "",
                        "TOWNHOUSE_LOC": "",
                        "PUIYRBUILT": "2012",
                        "PUIYRBUILT_ESTIMATED": "No",
                        "CONST_METHOD": "",
                        "CONVERTED_AREA": "",
                        "STRUCTURE_VOL": "",
                        "WINDOW_SURFACE_AREA": "",
                        "GROSS_FINISHED_AREA_SF": "",
                        "EXT_QUAL_RATING": "",
                        "EXT_COND_RATING": "",
                        "EXTEXTWALLS": "Stone",
                        "EXT_FEAT_COND_STATUS": "",
                        "Foundations": [
                            {
                                "EXT_FOUNDATION_DETAIL": "Sand | Natural",
                                "EXT_FOUNDATION_MATERIAL_DETAIL": "Sand",
                                "EXT_FOUNDATION_TYPE_DETAIL": "Natural",
                                "EXT_FOUNDATION_STATUS": ""
                            },
                            {
                                "EXT_FOUNDATION_DETAIL": "Brick | Natural",
                                "EXT_FOUNDATION_MATERIAL_DETAIL": "Brick",
                                "EXT_FOUNDATION_TYPE_DETAIL": "Natural",
                                "EXT_FOUNDATION_STATUS": ""
                            }
                        ],
                        "EXT_WINDOW_DETAIL_FLATTENED": "",
                        "EXT_WINDOW_DETAIL": "",
                        "EXT_WINDOW_STATUS": "",
                        "Roof": {
                            "EXTRFSURFACE": "",
                            "EXTRFSURFACE_OBSERVABLE": "",
                            "EXTRFSURFACE_TYPE": "",
                            "EXTRFSURFACE_AGE": "",
                        },
                        "EXTRFSURFACE_TYPE": "Asphalt",
                        "EXTRFSURFACE_OBSERVABLE": "Yes",
                        "FinishedAreaRoomSummary": [
                            {
                                "FINISHED_AREA_TOTAL_AREA_FLATTENED": "",
                                "FINISHED_AREA_TOTAL_AREA": "2300",
                                "FINISHED_AREA_ROOM_SUMMARY_TOTAL_ROOM": "",
                                "FINISHED_AREA_ROOM_SUMMARY_ROOM_TYPE": ""
                            }
                        ],
                        "Heating": [
                            {
                                "HEAT_SYSTEM_FLATTENED": "Fireplace | Wood ",
                                "HEAT_SYSTEM": "Fireplace",
                                "HEAT_DETAIL": "Electric"
                            },
                            {
                                "HEAT_SYSTEM_FLATTENED": "Baseboard | Natural Gas ",
                                "HEAT_SYSTEM": "Baseboard",
                                "HEAT_DETAIL": "Natural Gas"
                            }
                        ],
                        "Cooling": [
                            {
                                "COOL_SYSTEM": "Centralized",
                            }
                        ],
                        "OTHER_MECH_SYSTEM": "Test Data",
                        "Units": [
                            {
                                "FINISHED_ABOVE_GRADE": "",
                                "FINISHED_ABOVE_GRADE_NONSTD": "",
                                "UNFINISHED_ABOVE_GRADE": "",
                                "FINISHED_BELOW_GRADE": "",
                                "FINISHED_BELOW_GRADE_NONSTD": "",
                                "AREA_DATA_SOURCE_TYPE": "Public Records",
                                "UNIT_LEVELS": "",
                                "OCCUPANCY": "Owner",
                                "FLOOR_NUMBER": "",
                                "CORNER_UNIT": "",
                                "TOT_BEDS": "5",
                                "TOT_BATHS_FULL": "3",
                                "TOT_BATHS_HALF": "1",
                                "Levels": [
                                    {
                                        "LEVEL_IN_UNIT_FLATTENED": "Level 1 | Above Grade | 3006 | 0",
                                        "LEVEL_IN_UNIT": "Level 1",
                                        "LEVEL_GRADE_TYPE": "Above Grade",
                                        "LEVEL_BELOW_GRADE_ACCESS": "",
                                        "LEVEL_BELOW_GRADE_EXTERIOR_ACCESS": "",
                                        "LEVEL_FINISHED_AREA": "3006",
                                        "LEVEL_FINISHED_AREA_NONSTANDARD": "",
                                        "LEVEL_UNFINISHED_AREA": "0"
                                    },
                                    {
                                        "LEVEL_IN_UNIT_FLATTENED": "Level 2 | Above Grade | 1127 | 0",
                                        "LEVEL_IN_UNIT": "Level 2",
                                        "LEVEL_GRADE_TYPE": "Above Grade",
                                        "LEVEL_BELOW_GRADE_ACCESS": "",
                                        "LEVEL_BELOW_GRADE_EXTERIOR_ACCESS": "",
                                        "LEVEL_FINISHED_AREA": "1127",
                                        "LEVEL_FINISHED_AREA_NONSTANDARD": "",
                                        "LEVEL_UNFINISHED_AREA": "0"
                                    }
                                ],
                                "Rooms": [
                                    {
                                        "ROOM_LEVEL_FLATTENED": "Level B1 | Bedroom",
                                        "ROOM_LEVEL": "Level B1",
                                        "ROOM_ROOM_TYPE": "Bedroom"
                                    },
                                    {
                                        "ROOM_LEVEL_FLATTENED": "Level B1 | Bedroom",
                                        "ROOM_LEVEL": "Level B1",
                                        "ROOM_ROOM_TYPE": "Bedroom"
                                    },
                                    {
                                        "ROOM_LEVEL_FLATTENED": "Level B1 | Bedroom",
                                        "ROOM_LEVEL": "Level B1",
                                        "ROOM_ROOM_TYPE": "Bedroom"
                                    },
                                    {
                                        "ROOM_LEVEL_FLATTENED": "Level 1 | Bedroom",
                                        "ROOM_LEVEL": "Level 1",
                                        "ROOM_ROOM_TYPE": "Bedroom"
                                    },
                                    {
                                        "ROOM_LEVEL_FLATTENED": "Level 1 | Bedroom",
                                        "ROOM_LEVEL": "Level 1",
                                        "ROOM_ROOM_TYPE": "Bedroom"
                                    },
                                    {
                                        "ROOM_LEVEL_FLATTENED": "Level 1 | Bath - Full",
                                        "ROOM_LEVEL": "Level 1",
                                        "ROOM_ROOM_TYPE": "Bath - Full"
                                    },
                                    {
                                        "ROOM_LEVEL_FLATTENED": "Level 1 | Bath - Full",
                                        "ROOM_LEVEL": "Level 1",
                                        "ROOM_ROOM_TYPE": "Bath - Full"
                                    }
                                ],
                                "Mechanical": [
                                    {
                                        "OTHER_MECH_SYSTEM": ""
                                    }
                                ]
                            }
                        ],
                        "HEAT_BELOW_GRADE_FLATTENED": "",
                        "HEAT_BELOW_GRADE_YES": "",
                        "HEAT_BELOW_GRADE_NO": "",
                        "Defects": [
                            {
                                "DEFECT_FEATURE_FLATTENED": "",
                                "DEFECT_FEATURE": "",
                                "DEFECT_LOCATION": "",
                                "DEFECT_DESC": "",
                                "DEFECT_INTEGRITY": "",
                                "DEFECT_RECOMMEND_ACTION": ""
                            }
                        ]
                    }
                ],
                "VehicleStorage": [
                    {
                        "VS_CAR_STORAGE": "Garage | Attached | 1170",
                        "VS_PU_STORAGE_NUMBER_SPACES": "",
                        "VS_PU_STORAGE_SPACE_SQUARE_FEET": "1170",
                        "VS_PU_CAR_STORAGE_YES": "",
                        "VS_PU_CAR_STORAGE_NO": "",
                        "VS_PU_DRIVEWAY_SURFACE_MATERIAL": "",
                        "VS_PU_PARKING_SPACE_ASSIGNMENT": "",
                        "VS_PU_STORAGE_TYPE_DETAIL": "Attached",
                        "VS_PU_CAR_STORAGE_TYPE": "Garage"
                    },
                    {
                        "VS_CAR_STORAGE": "Driveway | 5 | Brick",
                        "VS_PU_STORAGE_NUMBER_SPACES": "5",
                        "VS_PU_STORAGE_SPACE_SQUARE_FEET": "",
                        "VS_PU_CAR_STORAGE_YES": "",
                        "VS_PU_CAR_STORAGE_NO": "",
                        "VS_PU_DRIVEWAY_SURFACE_MATERIAL": "Brick",
                        "VS_PU_PARKING_SPACE_ASSIGNMENT": "",
                        "VS_PU_STORAGE_TYPE_DETAIL": "",
                        "VS_PU_CAR_STORAGE_TYPE": "Driveway"
                    }
                ],
                "Amenities": [
                    {
                        "AmenityCategory": [
                            {
                                "SPA_AMENITY_CATEGORY": "Patio | Concrete | 230",
                                "PU_SPA_AMENITY_CATEGORY": "Patio",
                                "PU_SPA_AMENITY_TYPE": "Patio",
                                "PU_SPA_AMENITY_MATERIAL": "Concrete",
                                "PU_SPA_AMENITY_TOTALNUM": "",
                                "PU_SPA_AMENITY_DETAIL_AREA": "230",
                                "PU_SPA_AMENITY_DETAIL_AREA_UNIT": "",
                                "PU_SPA_AMENITY_DETAIL_FEATURE": ""
                            },
                            {
                                "SPA_AMENITY_CATEGORY": "Indoor Fireplace | 1 Story | 1",
                                "PU_SPA_AMENITY_CATEGORY": "Indoor Fireplace",
                                "PU_SPA_AMENITY_TYPE": "Indoor Fireplace",
                                "PU_SPA_AMENITY_MATERIAL": "1 Story",
                                "PU_SPA_AMENITY_TOTALNUM": "1",
                                "PU_SPA_AMENITY_DETAIL_AREA": "",
                                "PU_SPA_AMENITY_DETAIL_AREA_UNIT": "",
                                "PU_SPA_AMENITY_DETAIL_FEATURE": ""
                            }
                        ]
                    }
                ],
                "Outbuildings": [
                    {
                        "OUTBUILDING_TYPE": "Barn",
                        "CONSIDERED_REAL_PROP": "",
                        "TOTAL_AREA_FINISHED": "",
                        "TOTAL_AREA_UNFINISHED": "",
                        "HEATING_FLATTENED": "",
                        "HEATING_YES": "",
                        "HEATING_NO": "",
                        "MECH_HEAT_FLATTENED": "",
                        "MECH_HEAT_SYSTEM": "",
                        "MECH_HEAT_DETAIL": "",
                        "MECH_COOL_SYSTEM": "",
                        "OTH_MECH_SYSTEMS": "",
                        "COOLING_FLATTENED": "",
                        "COOLING_YES": "",
                        "COOLING_NO": ""
                    },
                    {
                        "OUTBUILDING_TYPE": "Boathouse",
                        "CONSIDERED_REAL_PROP": "",
                        "TOTAL_AREA_FINISHED": "",
                        "TOTAL_AREA_UNFINISHED": "",
                        "HEATING_FLATTENED": "",
                        "HEATING_YES": "",
                        "HEATING_NO": "",
                        "MECH_HEAT_FLATTENED": "",
                        "MECH_HEAT_SYSTEM": "",
                        "MECH_HEAT_DETAIL": "",
                        "MECH_COOL_SYSTEM": "",
                        "OTH_MECH_SYSTEMS": "",
                        "COOLING_FLATTENED": "",
                        "COOLING_YES": "",
                        "COOLING_NO": ""
                    },
                    {
                        "OUTBUILDING_TYPE": "Greenhouse",
                        "CONSIDERED_REAL_PROP": "",
                        "TOTAL_AREA_FINISHED": "",
                        "TOTAL_AREA_UNFINISHED": "",
                        "HEATING_FLATTENED": "",
                        "HEATING_YES": "",
                        "HEATING_NO": "",
                        "MECH_HEAT_FLATTENED": "",
                        "MECH_HEAT_SYSTEM": "",
                        "MECH_HEAT_DETAIL": "",
                        "MECH_COOL_SYSTEM": "",
                        "OTH_MECH_SYSTEMS": "",
                        "COOLING_FLATTENED": "",
                        "COOLING_YES": "",
                        "COOLING_NO": ""
                    }
                ],
                "SC_CONTRACT_SALES_PRICE": "",
                "SC_CONTRACT_DATE": "",
                "SC_TRANSFER_TERMS": "",
                "SC_CONCESSIONS_FLATTENED": "",
                "SC_KWN_CONCESSIONS": "",
                "SC_TOTAL_CONCESSIONS": "",
                "FO_FUNCTIONAL_ISSUE_TYPE": ""
            }
        }

        return data;
}

function SEBestCompPayload(): any {
    const data = {
    "records": 2,
    "yourCount": 0,
    "peerCount": 2,
    "reportUseCount": 1,
    "isPeerComp": true,
    "sourceData": {
        "COMP_PHOTO": "",
        "AD_ADDR1": "539 Shirley LN NE",
        "DB_UNITNO": "",
        "DB_CITY": "Piedmont",
        "DB_STATE": "OK",
        "DB_ZIP": "73078",
        "SC_SOURCE1": "MLS",
        "PU_DATA_SOURCE": "MLS",
        "PU_DATA_SOURCE_ASSESSOR_ID": "MLS",
        "PU_DATA_SOURCE_MLS_NUM": "1",
        "PROX1": "0.5 miles NW",
        "PU_DISTANCE": "0.5",
        "PU_MILES": "0.5",
        "PU_KILOMETERS": "0.5",
        "PU_DIRECTION": "Standard Direction",
        "LP_PRICE": "350000",
        "LP_STATUS": "Closed",
        "CONT_PRICE": "350000",
        "PU_CONT_PRICE_KNOWN": "350000",
        "PU_CONT_PRICE": "350000",
        "PR_SALEPR1": "350000",
        "TRANSFER_TERMS": "1850",
        "DP_FINTYP1": "Conventional",
        "EX_CONCAMT": "350000",
        "PU_CONC_PRESENT": "Standard Concessions Present",
        "PU_CONC_AMOUNT": "Standard Concession Amount",
        "CONT_DATE": "2026-04-15",
        "PU_CONT_DATE_KNOWN": "2026-04-15",
        "PU_CONT_DATE": "2026-04-15",
        "DT_SALTIM1": "2026-04-15",
        "EX_DOM": "24",
        "SP_TO_LP_RATIO": "350000",
        "ATT_DET": "Detached",
        "PROP_APPRAISER_RIGHTS": "Standard Property Rights Appraised",
        "ANNUAL_GRND_RENT": "Standard Annual Ground Rent",
        "NATIVE_AM_LANDS": "Standard Native American Lands",
        "PU_NATIVE_AM_LANDS_YES": "1",
        "PU_NATIVE_AM_LANDS_NO": "0",
        "PU_NATIVE_AM_LANDS_TYPE": "Standard Native American Lands Type",
        "ALL_RIGHTS_INCLUDED": "Standard All Rights Included",
        "RIGHTS_NOT_INCLUDED": "Standard Rights Not Included",
        "SAME_BLDR_AS_SUBJECT": "Standard Same Builder as Subject",
        "GI_BLANK": "",
        "PROJ_NAME": "Standard Project Name ",
        "PU_PROJECT_NAME": "RES-WAWONA DRIVE",
        "PU_SAME_PROJECT_AS_SUBJECT": "Standard Same Project",
        "PROJ_MONTHLY_FEE": "Standard Monthly Fee",
        "PROJ_AMENITIES": "None",
        "PROJ_SPECIAL_ASSESSMENTS": "Standard Special Assessments",
        "SITE_PROJECT_TYPE": "Standard Project Type",
        "SITE_OWNED_IN_COMMON": "Standard Site Owned In Common",
        "ST_SITSIZE": "0.25",
        "MARKETAREA": "Oakridge Estates",
        "SITE_ZONE_COMPLIANCE": "Standard Zoning Compliance",
        "SITE_HAZARD_ZONE": "Standard Hazard Zone",
        "SITE_PRIMARY_ACCESS": "Standard Primary Access",
        "SiteStreetType": [
            {
                "SITE_STREET_TYPE": "Cul-de-sac | Paved",
                "PU_SITE_STREET_TYPE": "Cul-de-sac",
                "PU_SITE_STREET_SURFACE": "Paved"
            },
            {
                "SITE_STREET_TYPE": "Dead End | Paved",
                "PU_SITE_STREET_TYPE": "Dead End",
                "PU_SITE_STREET_SURFACE": "Paved"
            }
        ],
        "SITE_PROP_RESTRICT": "Standard Property Restriction",
        "SITE_EASEMENT": "Standard Easement",
        "SITE_TOPOGRAPHY": "Standard Topography",
        "SiteDrainage": [
            {
                "SITE_DRAINAGE": "Standard Drainage"
            },
            {
                "SITE_DRAINAGE": "Complex Drainage"
            }
        ],
        "SITE_CHARACTERISTICS": "Standard Site Characteristics",
        "SITE_INFLUENCE": "Standard Site Influence",
        "PU_SITE_INFLUENCE": "Standard Site Influence",
        "PU_SITE_INFLUENCE_PRIVATE_ACCESS": "Standard Site Influence Private Access",
        "PU_SITE_INFLUENCE_WATER_TYPE": "Standard Site Influence Water Type",
        "SITE_ENV_COND": "C3",
        "SiteViews": [
            {
                "ST_VIEW": "Creek | Seasonal",
                "PU_ST_VIEW": "Creek",
                "PU_ST_RANGE": "Seasonal"
            },
            {
                "ST_VIEW": "Marsh | Partial",
                "PU_ST_VIEW": "Marsh",
                "PU_ST_RANGE": "Partial"
            }
        ],
        "SITE_BLANK": "",
        "Dwellings": [
            {
                "YR_BLT": "1970 | No",
                "PU_YR_BLT": "1970",
                "PU_YR_BLT_EST": "No",
                "DWELL_DESIGN": "Colonial",
                "PU_STRUCTURE_DESIGN": "Colonial",
                "SF_GLA": "1850",
                "SF_FINISHED_AREA": "1850",
                "DWELL_TH_BACKTOBACK": "Standard Townhouse Back to Back",
                "PU_DWELL_TH_BACKTOBACK": "Standard Townhouse Back to Back",
                "DWELL_TH_LOC": "Standard Townhouse Location",
                "PU_DWELL_TH_LOC": "Standard Townhouse Location",
                "DWELL_CONST_METHOD": "Stick Built",
                "PU_DWELL_CONST_METHOD": "Stick Built",
                "DWELL_MANFCT_HOME_WIDTH": "12-34-567-890",
                "PU_DWELL_MANFCT_HOME_WIDTH": "12-34-567-890",
                "DWELL_STYLE": "Colonial",
                "PU_DWELL_STYLE": "Colonial",
                "DWELL_TOTAL_VOLUME": "1850",
                "DWELL_WINDOW_AREA": "1850",
                "DWELL_FUNC_ISSUES": "Standard Functional Issues",
                "PU_DWELL_FUNC_ISSUES": "Standard Functional Issues",
                "DWELL_DISASTER_MIT": "Standard Disaster Mitigation",
                "PU_DWELL_DISASTER_MIT": "Standard Disaster Mitigation",
                "Heating": [
                    {
                        "DWELL_HEAT": "CENTRAL",
                        "PU_DWELL_HEAT_SYSTEM": "CENTRAL",
                        "PU_DWELL_HEAT_DETAIL": ""
                    }
                ],
                "Cooling": [
                    {
                        "DWELL_COOL": "Centralized",
                        "PU_DWELL_COOL": "Centralized"
                    }
                ],
                "DWELL_OTHR1_BLANK": "",
                "Units": [
                    {
                        "UNIT_ID": "Apt 4B",
                        "UNITS_IS_AN_ADU": "Apt 4B",
                        "LOC_ADU": "Standard Location of ADU",
                        "PU_LOC_ADU_TYPE": "Standard Location Type",
                        "PU_LOC_ADU_DESC": "Standard Location Description",
                        "FLOOR_NUM": "1",
                        "CORNER_UNIT": "Apt 4B",
                        "LEVELS": "Apt 4B",
                        "BEDS": "5",
                        "BATHS": "3",
                        "PU_FULL_BATHS": "3",
                        "PU_HALF_BATHS": "2.5",
                        "UNITS_SF_GLA": "1850",
                        "UNITS_SF_GLA_NONSTD": "1850",
                        "UNITS_SF_GLA_UNFIN": "1850",
                        "UNITS_SF_GLA_BELOW_GRD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_NONSTD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_UNFIN": "1850",
                        "DISABILITY_FEATURES": "Standard Features for Individuals w/Disabilities",
                        "UNITS_BLANK": ""
                    },
                    {
                        "UNIT_ID": "Apt 5B",
                        "UNITS_IS_AN_ADU": "5B",
                        "LOC_ADU": "Standard Location of ADU",
                        "PU_LOC_ADU_TYPE": "Standard Location Type",
                        "PU_LOC_ADU_DESC": "Standard Location Description",
                        "FLOOR_NUM": "1",
                        "CORNER_UNIT": "Apt 5B",
                        "LEVELS": "5B",
                        "BEDS": "5",
                        "BATHS": "3",
                        "PU_FULL_BATHS": "3",
                        "PU_HALF_BATHS": "2.5",
                        "UNITS_SF_GLA": "1850",
                        "UNITS_SF_GLA_NONSTD": "1850",
                        "UNITS_SF_GLA_UNFIN": "1850",
                        "UNITS_SF_GLA_BELOW_GRD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_NONSTD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_UNFIN": "1850",
                        "DISABILITY_FEATURES": "Standard Features for Individuals w/Disabilities",
                        "UNITS_BLANK": ""
                    },
                    {
                        "UNIT_ID": "Apt 6B",
                        "UNITS_IS_AN_ADU": "Apt 6B",
                        "LOC_ADU": "Standard Location of ADU",
                        "PU_LOC_ADU_TYPE": "Standard Location Type",
                        "PU_LOC_ADU_DESC": "Standard Location Description",
                        "FLOOR_NUM": "1",
                        "CORNER_UNIT": "Apt 6B",
                        "LEVELS": "6B",
                        "BEDS": "5",
                        "BATHS": "3",
                        "PU_FULL_BATHS": "3",
                        "PU_HALF_BATHS": "2.5",
                        "UNITS_SF_GLA": "1850",
                        "UNITS_SF_GLA_NONSTD": "1850",
                        "UNITS_SF_GLA_UNFIN": "1850",
                        "UNITS_SF_GLA_BELOW_GRD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_NONSTD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_UNFIN": "1850",
                        "DISABILITY_FEATURES": "Standard Features for Individuals w/Disabilities",
                        "UNITS_BLANK": ""
                    }
                ]
            },
            {
                "YR_BLT": "1971 | No",
                "PU_YR_BLT": "1971",
                "PU_YR_BLT_EST": "No",
                "DWELL_DESIGN": "Colonial",
                "PU_STRUCTURE_DESIGN": "Colonial",
                "SF_GLA": "1850",
                "SF_FINISHED_AREA": "1850",
                "DWELL_TH_BACKTOBACK": "Standard Townhouse Back to Back",
                "PU_DWELL_TH_BACKTOBACK": "Standard Townhouse Back to Back",
                "DWELL_TH_LOC": "Standard Townhouse Location",
                "PU_DWELL_TH_LOC": "Standard Townhouse Location",
                "DWELL_CONST_METHOD": "Stick Built",
                "PU_DWELL_CONST_METHOD": "Stick Built",
                "DWELL_MANFCT_HOME_WIDTH": "12-34-567-890",
                "PU_DWELL_MANFCT_HOME_WIDTH": "12-34-567-890",
                "DWELL_STYLE": "Colonial",
                "PU_DWELL_STYLE": "Colonial",
                "DWELL_TOTAL_VOLUME": "1850",
                "DWELL_WINDOW_AREA": "1850",
                "DWELL_FUNC_ISSUES": "Standard Functional Issues",
                "PU_DWELL_FUNC_ISSUES": "Standard Functional Issues",
                "DWELL_DISASTER_MIT": "Standard Disaster Mitigation",
                "PU_DWELL_DISASTER_MIT": "Standard Disaster Mitigation",
                "Heating": [
                    {
                        "DWELL_HEAT": "CENTRAL",
                        "PU_DWELL_HEAT_SYSTEM": "CENTRAL",
                        "PU_DWELL_HEAT_DETAIL": ""
                    }
                ],
                "Cooling": [
                    {
                        "DWELL_COOL": "Centralized",
                        "PU_DWELL_COOL": "Centralized"
                    }
                ],
                "DWELL_OTHR1_BLANK": "",
                "Units": [
                    {
                        "UNIT_ID": "Apt 8B1",
                        "UNITS_IS_AN_ADU": "Apt 8B1",
                        "LOC_ADU": "Standard Location of ADU",
                        "PU_LOC_ADU_TYPE": "Standard Location Type",
                        "PU_LOC_ADU_DESC": "Standard Location Description",
                        "FLOOR_NUM": "1",
                        "CORNER_UNIT": "Apt 8B1",
                        "LEVELS": "Apt 8B1",
                        "BEDS": "5",
                        "BATHS": "3",
                        "PU_FULL_BATHS": "3",
                        "PU_HALF_BATHS": "2.5",
                        "UNITS_SF_GLA": "1850",
                        "UNITS_SF_GLA_NONSTD": "1850",
                        "UNITS_SF_GLA_UNFIN": "1850",
                        "UNITS_SF_GLA_BELOW_GRD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_NONSTD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_UNFIN": "1850",
                        "DISABILITY_FEATURES": "Standard Features for Individuals w/Disabilities",
                        "UNITS_BLANK": ""
                    },
                    {
                        "UNIT_ID": "Apt 9C1",
                        "UNITS_IS_AN_ADU": "Apt 9C1",
                        "LOC_ADU": "Standard Location of ADU",
                        "PU_LOC_ADU_TYPE": "Standard Location Type",
                        "PU_LOC_ADU_DESC": "Standard Location Description",
                        "FLOOR_NUM": "1",
                        "CORNER_UNIT": "Apt 9C1",
                        "LEVELS": "Apt 9C1",
                        "BEDS": "5",
                        "BATHS": "3",
                        "PU_FULL_BATHS": "3",
                        "PU_HALF_BATHS": "2.5",
                        "UNITS_SF_GLA": "1850",
                        "UNITS_SF_GLA_NONSTD": "1850",
                        "UNITS_SF_GLA_UNFIN": "1850",
                        "UNITS_SF_GLA_BELOW_GRD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_NONSTD": "1850",
                        "UNITS_SF_GLA_BELOW_GRD_UNFIN": "1850",
                        "DISABILITY_FEATURES": "Standard Features for Individuals w/Disabilities",
                        "UNITS_BLANK": ""
                    },
                ]
            }
        ],
        "WaterFrontages": [
            {
                "WATER_FRONTAGE": "Creek | Deer Creek | Shallow Water",
                "PU_WATER_FRONTAGE_TYPE": "Creek",
                "PU_WATER_FRONTAGE_NAME": "Deer Creek",
                "PU_WATER_FRONTAGE_ACCESS_DEPTH": "Shallow Water"
            },
            {
                "WATER_FRONTAGE": "Marsh | Non-Navigable",
                "PU_WATER_FRONTAGE_TYPE": "Marsh",
                "PU_WATER_FRONTAGE_NAME": "",
                "PU_WATER_FRONTAGE_ACCESS_DEPTH": "Non-Navigable"
            }
        ],
        "WATER_FRONTAGE_FEAT": "147233",
        "WATER_RIGHT_BLD": "Standard Right to Build",
        "WATER_LINEAR_MEASURE": "Standard Total Linear Measurement",
        "PU_WATER_LINEAR_MEASURE": "Standard Water Linear Measure",
        "PU_WATER_LINEAR_MEASURE_FEET": "Standard Water Linear Measure Feet",
        "PU_WATER_LINEAR_MEASURE_METERS": "Standard Water Linear Measure Meters",
        "GREEN_RENEW_ENERGY_ONENT": "Standard Renewable Energy Component",
        "BuildingCertifications": [
            {
                "GREEN_BUILD_CERT": "Certification 1 | 19%",
                "PU_GREEN_BUILD_CERT_DESC": "Certification",
                "PU_GREEN_BUILD_CERT_RATE": "19%"
            },
            {
                "GREEN_BUILD_CERT": "Certification 2 | 27%",
                "PU_GREEN_BUILD_CERT_DESC": "Certification 2",
                "PU_GREEN_BUILD_CERT_RATE": "27%"
            }
        ],
        "EfficiencyRatings": [
            {
                "GREEN_EFF_RATING": "C- | 70",
                "PU_GREEN_EFF_RATING": "C-",
                "PU_GREEN_EFF_SCORE": "70"
            },
            {
                "GREEN_EFF_RATING": "A | 93",
                "PU_GREEN_EFF_RATING": "A",
                "PU_GREEN_EFF_SCORE": "93"
            }
        ],
        "ExteriorQualities" : [
            {
                "EXT_QUAL_STRUCTURE_ID": "Q3",
                "EXT_QUAL_QUALITY": "Q3",
                "EXT_QUAL_EXT_WALLS_TRIM": "Standard / Typical",
                "EXT_QUAL_FOUNDATION": "Standard / Typical",
                "EXT_QUAL_ROOF": "Standard / Typical",
                "EXT_QUAL_WINDOWS": "Q3",
                "BLExteriorQualities" : [
                    {
                        "EXT_QUAL_BLANK_LABEL": "",
                        "EXT_QUAL_BLANK": "",
                    }
                ],
            },
            {
                "EXT_QUAL_STRUCTURE_ID": "Q3",
                "EXT_QUAL_QUALITY": "Q3",
                "EXT_QUAL_EXT_WALLS_TRIM": "Standard / Typical",
                "EXT_QUAL_FOUNDATION": "Standard / Typical",
                "EXT_QUAL_ROOF": "Standard / Typical",
                "EXT_QUAL_WINDOWS": "Q3",
                "BLExteriorQualities" : [
                    {
                        "EXT_QUAL_BLANK_LABEL": "",
                        "EXT_QUAL_BLANK": "",
                    }
                ],
            },
        ],
        "ExteriorConditions" : [
            {
                "EXT_COND_CONDITION": "A3",
                "EXT_COND_WALLS_TRIM": "Standard / Typical",
                "EXT_COND_FOUNDATION": "Standard / Typical",
                "EXT_COND_ROOF": "Standard / Typical",
                "PU_EXT_COND_ROOF_OBSERVABLE": "Standard / Typical",
                "PU_EXT_COND_ROOF_STATUS": "Standard / Typical",
                "EXT_COND_WINDOWS": "A3",
                "BLExteriorConditions" : [
                    {
                        "EXT_COND_BLANK_LABEL": "",
                        "EXT_COND_BLANK": "",
                    }
                ],
            },
            {
                "EXT_COND_CONDITION": "B3",
                "EXT_COND_WALLS_TRIM": "Standard / Typical",
                "EXT_COND_FOUNDATION": "Standard / Typical",
                "EXT_COND_ROOF": "Standard / Typical",
                "PU_EXT_COND_ROOF_OBSERVABLE": "Standard / Typical",
                "PU_EXT_COND_ROOF_STATUS": "Standard / Typical",
                "EXT_COND_WINDOWS": "B3",
                "BLExteriorConditions" : [
                    {
                        "EXT_COND_BLANK_LABEL": "",
                        "EXT_COND_BLANK": "",
                    }
                ],
            },
        ],
        "InteriorQualities" : [
            {
                "INT_QUAL_STRUCTURE_ID": "Apt 4B",
                "INT_QUAL_QUALITY": "Q3",
                "INT_QUAL_KITCHEN": "Q3",
                "INT_QUAL_BATHS": "2.5",
                "INT_QUAL_FLOORS": "Q3",
                "INT_QUAL_WALLS_CEILINGS": "Standard / Typical",
                "INT_QUAL_BLANK": "",
                "BLInteriorQuality" : [
                    {
                        "INT_QUAL_BLANK_LABEL": "",
                        "INT_QUAL_BLANK": "",
                    }
                ],
            },
            {
                "INT_QUAL_STRUCTURE_ID": "Apt 4C",
                "INT_QUAL_QUALITY": "Q3",
                "INT_QUAL_KITCHEN": "Q3",
                "INT_QUAL_BATHS": "2.5",
                "INT_QUAL_FLOORS": "Q3",
                "INT_QUAL_WALLS_CEILINGS": "Standard / Typical",
                "INT_QUAL_BLANK": "",
                "BLInteriorQuality" : [
                    {
                        "INT_QUAL_BLANK_LABEL": "",
                        "INT_QUAL_BLANK": "",
                    }
                ],
            }
        ],
        "InteriorConditions" : [
            {
                "INT_COND_CONDITION": "C3",
                "INT_COND_KITCHEN": "C3",
                "INT_COND_BATHS": "2.5",
                "INT_COND_FLOORS": "C3",
                "INT_COND_WALLS_CEILINGS": "Standard / Typical",
                "BLInteriorConditions" : [
                    {
                        "INT_COND_BLANK_LABEL": "",
                        "INT_COND_BLANK": "",
                    }
                ],
            },
            {
                "INT_COND_CONDITION": "K3",
                "INT_COND_KITCHEN": "K3",
                "INT_COND_BATHS": "2.5",
                "INT_COND_FLOORS": "K3",
                "INT_COND_WALLS_CEILINGS": "Standard / Typical",
                "BLInteriorConditions" : [
                    {
                        "INT_COND_BLANK_LABEL": "",
                        "INT_COND_BLANK": "",
                    }
                ],
            }
        ],
        "ADUQualities" : [
            {
                "ADU_LOCATION": "Standard ADU Location 1",
                "ADU_QUAL_QUALITY": "Q3",
                "ADU_QUAL_KITCHEN": "Q3",
                "INT_ADU_COND_BATHS": "2.5",
                "ADU_QUAL_FLOORS": "Q3",
                "ADU_QUAL_WALLS_CEILINGS": "Standard / Typical",
                "ADU_QUAL_BLANK": "",
                "BLADUQualities" : [
                    {
                        "ADU_QUAL_BLANK_LABEL": "",
                        "ADU_QUAL_BLANK": "",
                    }
                ]
            },
            {
                "ADU_LOCATION": "Standard ADU Location 2",
                "ADU_QUAL_QUALITY": "Q3",
                "ADU_QUAL_KITCHEN": "Q3",
                "INT_ADU_COND_BATHS": "2.5",
                "ADU_QUAL_FLOORS": "Q3",
                "ADU_QUAL_WALLS_CEILINGS": "Standard / Typical",
                "ADU_QUAL_BLANK": "",
                "BLADUQualities" : [
                    {
                        "ADU_QUAL_BLANK_LABEL": "",
                        "ADU_QUAL_BLANK": "",
                    }
                ]
            }
        ],
        "ADUConditions" : [
            {
                "ADU_COND_CONDITION": "C3",
                "ADU_COND_KITCHEN": "C3",
                "ADU_COND_BATHS": "2.5",
                "ADU_COND_FLOORS": "C3",
                "ADU_COND_WALLS_CEILINGS": "Standard / Typical",
                "ADU_COND_BLANK": "",
                "BLADUConditions" : [
                    {
                        "ADU_COND_BLANK_LABEL": "",
                        "ADU_COND_BLANK": "",
                    }
                ],
            },
            {
                "ADU_COND_CONDITION": "D3",
                "ADU_COND_KITCHEN": "D3",
                "ADU_COND_BATHS": "2.5",
                "ADU_COND_FLOORS": "D3",
                "ADU_COND_WALLS_CEILINGS": "Standard / Typical",
                "ADU_COND_BLANK": "",
                "BLADUConditions" : [
                    {
                        "ADU_COND_BLANK_LABEL": "",
                        "ADU_COND_BLANK": "",
                    }
                ],
            }
        ],
        "QUALITY": "Q3",
        "CONDITION": "C3",
        "Amenities": [
            {
                "OutdoorAccessories": [
                    {
                        "AMENITY_OUTDOOR_ACCESSORIES": "Outdoor Firpit | 1",
                        "PU_AMENITY_OUTDOOR_ACCESSORIES": "Outdoor Firpit",
                        "PU_AMENITY_OUTDOOR_ACCESSORIES_NUM": "1"
                    }
                ],
                "OutdoorLiving": [
                    {
                        "AMENITY_OUTDOOR_LIVING": "Deck | 3 | 96",
                        "PU_AMENITY_OUTDOOR_LIVING": "Deck"
                    },
                    {
                        "AMENITY_OUTDOOR_LIVING": "Porch | 384",
                        "PU_AMENITY_OUTDOOR_LIVING": "Porch"
                    }
                ],
                "WaterFeatures": [
                    {
                        "AMENITY_WATER_FEATURES": "Outdoor Shower | 1 | 1",
                        "PU_AMENITY_WATER_FEATURE": "Outdoor Shower",
                        "PU_AMENITY_WATER_FEATURE_DETAIL": "1",
                        "PU_AMENITY_WATER_FEATURE_NUM": "1"
                    }
                ],
                "WholeHome": [
                    {
                        "AMENITY_WHOLE_HOME": "Elevator | 1",
                        "PU_AMENITY_WHOLE_HOME": "Elevator",
                        "PU_AMENITY_WHOLE_HOME_NUM": "1"
                    }
                ],
                "Miscellaneous": [
                    {
                        "AMENITY_MISC": "Indoor Fireplace | 1",
                        "PU_AMENITY_MISC": "Indoor Fireplace",
                        "PU_AMENITY_MISC_NUM": "1"
                    }
                ]
            }
        ],
        "VehicleStorage": [
            {
                "VEHICLE_STORAGE": "Garage | Attached | 1165",
                "PU_VEHICLE_STORAGE": "Garage",
                "PU_VEHICLE_STORAGE_SPACES": "",
                "PU_VEHICLE_STORAGE_DETAILS": "Attached",
                "PU_VEHICLE_STORAGE_SQFT": "1165",
                "BL_VEHICLE_STORAGE": ""
            },
            {
                "VEHICLE_STORAGE": "Carport | 2 | Attached | 1170",
                "PU_VEHICLE_STORAGE": "Carport",
                "PU_VEHICLE_STORAGE_SPACES": "2",
                "PU_VEHICLE_STORAGE_DETAILS": "Attached",
                "PU_VEHICLE_STORAGE_SQFT": "1170",
                "BL_VEHICLE_STORAGE": ""
            },
            {
                "VEHICLE_STORAGE": "Driveway | 4 | Asphalt",
                "PU_VEHICLE_STORAGE": "Driveway",
                "PU_VEHICLE_STORAGE_SPACES": "4",
                "PU_VEHICLE_STORAGE_DETAILS": "Asphalt",
                "PU_VEHICLE_STORAGE_SQFT": "",
                "BL_VEHICLE_STORAGE": ""
            }
        ],
        "Outbuildings": [
            {
                "OUTBUILDING_TYPE": "Manufactured Home",
                "OUTBUILDING_REAL_PROPERTY": "Yes",
                "OUTBUILDING_BUILDING_AREA": "5000",
                "OUTBUILDING_FINISHED_AREA": "5000",
                "OUTBUILDING_UNFINISHED_AREA": "0",
                "OUTBUILDING_STRUCTURE_VOLUME": "4000",
                "OUTBUILDING_BATHS_FULL": "1",
                "OUTBUILDING_BATHS_HALF": "2",
                "OUTBUILDING_KITCHENS": "1",
                "OUTBUILDING_HEATING": "Yes",
                "OUTBUILDING_COOLING": "Yes",
                "OutbuildingUtilities": [
                    {
                        "OUTBUILDING_UTILITIES": "Electricity"
                    },
                    {
                        "OUTBUILDING_UTILITIES": "Water"
                    }
                ],
                "BLOutbuilding": [ // CURRENTLY NOT USED 
                    {
                        "BL_OUTBUILDING_BLANK": "",
                        "BL_OUTBUILDING": ""
                    }
                ]
            },
            {
                "OUTBUILDING_TYPE": "Barn",
                "OUTBUILDING_REAL_PROPERTY": "Yes",
                "OUTBUILDING_BUILDING_AREA": "5000",
                "OUTBUILDING_FINISHED_AREA": "5000",
                "OUTBUILDING_UNFINISHED_AREA": "0",
                "OUTBUILDING_STRUCTURE_VOLUME": "4000",
                "OUTBUILDING_BATHS_FULL": "1",
                "OUTBUILDING_BATHS_HALF": "2",
                "OUTBUILDING_KITCHENS": "1",
                "OUTBUILDING_HEATING": "Yes",
                "OUTBUILDING_COOLING": "Yes",
                "OutbuildingUtilities": [
                    {
                        "OUTBUILDING_UTILITIES": "Sewer"
                    }
                ],
                "BLOutbuilding": [ // CURRENTLY NOT USED 
                    {
                        "BL_OUTBUILDING_BLANK": "",
                        "BL_OUTBUILDING": ""
                    }
                ]
            },
        ],
        "TransferHistories": [
            {
                "TRANSFER_HISTORY_PRESENT": "1950",
                "TRANSFER_HISTORY_TERMS": "1950",
                "TRANSFER_HISTORY_DATE": "2026-04-15",
                "TRANSFER_HISTORY_AMOUNT": "50000",
                "DFE_TRANSFER_HISTORY_AMOUNT_VALUE": "50000",
                "DFE_TRANSFER_HISTORY_AMOUNT_REASON": "1950",
                "TRANSFER_HISTORY_SOURCE": "1950",
            },
            {
                "TRANSFER_HISTORY_PRESENT": "2000",
                "TRANSFER_HISTORY_TERMS": "2000",
                "TRANSFER_HISTORY_DATE": "2026-04-15",
                "TRANSFER_HISTORY_AMOUNT": "150000",
                "DFE_TRANSFER_HISTORY_AMOUNT_VALUE": "150000",
                "DFE_TRANSFER_HISTORY_AMOUNT_REASON": "2000",
                "TRANSFER_HISTORY_SOURCE": "2000",
            },
            {
                "TRANSFER_HISTORY_PRESENT": "2000",
                "TRANSFER_HISTORY_TERMS": "2000",
                "TRANSFER_HISTORY_DATE": "2026-04-15",
                "TRANSFER_HISTORY_AMOUNT": "150000",
                "DFE_TRANSFER_HISTORY_AMOUNT_VALUE": "150000",
                "DFE_TRANSFER_HISTORY_AMOUNT_REASON": "2000",
                "TRANSFER_HISTORY_SOURCE": "2000",
            }
        ]
    }
    }

    return data;
}